import {
  AD_ACCOUNT_GOOGLE_PLACEHOLDER,
  AD_ACCOUNT_META_PLACEHOLDER,
  AD_ACCOUNT_TIKTOK_PLACEHOLDER,
  ALERT_AD_ACCOUNT_STATUS_LABEL,
  ALERT_CAMPAIGN_CPA_HIGH_LABEL,
  ALERT_CAMPAIGN_STARTED_LABEL,
  ALERT_PIXEL_NOT_FIRED_LABEL,
  CHAT_QUESTION_1,
  CHAT_QUESTION_2,
  CHAT_QUESTION_3,
  CHAT_QUESTION_4,
  CHAT_QUESTION_5,
  CHAT_QUESTION_6,
  CHAT_QUESTION_7,
  CHAT_QUESTION_8,
  CHAT_QUESTION_9,
  IMAGE_TYPE_LANDSCAPE_LABEL,
  IMAGE_TYPE_PORTRAIT_LABEL,
  IMAGE_TYPE_SQUARE_LABEL,
  MAIN_STATISTIC_VALUE_AD_RECALL_CLARIFICATION,
  MAIN_STATISTIC_VALUE_CLICK_CLARIFICATION,
  MAIN_STATISTIC_VALUE_CPM_CLARIFICATION,
  MAIN_STATISTIC_VALUE_INSTAGRAM_PROFILE_CLARIFICATION,
  MAIN_STATISTIC_VALUE_LEAD_CLARIFICATION,
  MAIN_STATISTIC_VALUE_POST_ENGAGEMENT_CLARIFICATION,
  MAIN_STATISTIC_VALUE_PURCHASE_CLARIFICATION,
  MAIN_STATISTIC_VALUE_VIDEO_VIEW_CLARIFICATION,
  MODAL_CREATE_WITH_IA_DIMENSION_SQUARE,
  MODAL_CREATE_WITH_IA_DIMENSION_HORIZONTAL,
  MAP_STATUS_ACTIVE,
  MAP_STATUS_DEACTIVATED,
  MAP_TRADUCCIONES_STATUS,
  MAP_TRADUCCIONES_PLATFORM,
  MAP_TRADUCCIONES_CTA,
  MAP_TRADUCCIONES_CTAS,
  MAP_TRADUCCIONES_CTA_ID,
  MAP_TRADUCCIONES_MEDIA_URLS,
  MAP_TRADUCCIONES_MEDIA_DATA,
  MAP_TRADUCCIONES_MUSIC_URL,
  MAP_TRADUCCIONES_IS_CAROUSEL,
  MAP_TRADUCCIONES_OBJECTIVE,
  MAP_TRADUCCIONES_INTEGRATION_ID,
  MAP_TRADUCCIONES_AD_ACCOUNT_ID,
  MAP_TRADUCCIONES_PAGE_ID,
  MAP_TRADUCCIONES_INSTAGRAM_ID,
  MAP_TRADUCCIONES_USE_CAMPAIGN_BUDGET,
  MAP_TRADUCCIONES_TYPE_BUDGET,
  MAP_TRADUCCIONES_BUDGET,
  MAP_TRADUCCIONES_IS_CATALOG_CAMPAIGN,
  MAP_TRADUCCIONES_WHATSAPP_BUSINESS_NUMBER,
  MAP_TRADUCCIONES_MESSAGE_TEMPLATE,
  MAP_TRADUCCIONES_INSTANT_FORM,
  MAP_TRADUCCIONES_TRACKING_ID,
  MAP_TRADUCCIONES_TRACKING_CUSTOM_EVENT_ID,
  MAP_TRADUCCIONES_CATALOG_ID,
  MAP_TRADUCCIONES_IS_IOS14_CAMPAIGN,
  MAP_TRADUCCIONES_APP_ID,
  MAP_TRADUCCIONES_BUYING_TYPE,
  MAP_TRADUCCIONES_DESCRIPTIONS,
  MAP_TRADUCCIONES_ADS,
  MAP_TRADUCCIONES_KEYWORDS,
  MAP_TRADUCCIONES_KEYWORDS_NEGATIVE,
  MAP_TRADUCCIONES_START_DATE,
  MAP_TRADUCCIONES_END_DATE,
  MAP_TRADUCCIONES_AGE_RANGE,
  MAP_TRADUCCIONES_GENDERS,
  MAP_TRADUCCIONES_LOCATIONS,
  MAP_TRADUCCIONES_INTERESTS,
  MAP_TRADUCCIONES_BEHAVIORS,
  MAP_TRADUCCIONES_CUSTOM_AUDIENCES,
  MAP_TRADUCCIONES_EXCLUDED_CUSTOM_AUDIENCES,
  MAP_TRADUCCIONES_BID_GOAL,
  MAP_TRADUCCIONES_OPTIMIZATION_GOAL,
  MAP_TRADUCCIONES_IDENTITY_TIKTOK_ID,
  MAP_TRADUCCIONES_TYPE,
  MAP_TRADUCCIONES_ID,
  MAP_TRADUCCIONES_DESTINATION_URL,
  MAP_TRADUCCIONES_BUSINESS_NAME,
  MAP_TRADUCCIONES_LOGO_URLS,
  MAP_TRADUCCIONES_IMAGE_URLS,
  MAP_TRADUCCIONES_VIDEO_URLS,
  MAP_TRADUCCIONES_LONG_HEADLINES,
  MAP_TRADUCCIONES_SEARCH_THEMES,
  MAP_TRADUCCIONES_TITLES,
  TRACKING_CUSTOM_EVENT_ID_META_PLACEHOLDER,
  TRACKING_CUSTOM_EVENT_ID_TIKTOK_PLACEHOLDER,
  TRACKING_GOOGLE_ID_PLACEHOLDER,
  TRACKING_META_ID_PLACEHOLDER,
  TRACKING_TIKTOK_ID_PLACEHOLDER,
  MODAL_CREATE_WITH_IA_DIMENSION_VERTICAL,
  MODAL_CREATE_WITH_IA_IMAGE_TYPE_REALISTA,
  MODAL_CREATE_WITH_IA_IMAGE_TYPE_PRODUCTO,
  MODAL_CREATE_WITH_IA_MEDIA_TYPE_IMAGE,
  MODAL_CREATE_WITH_IA_MEDIA_TYPE_VIDEO,
  MODAL_CREATE_WITH_IA_MEDIA_TYPE_CAROUSEL,
  ASPECT_RATIO_9_16,
  ASPECT_RATIO_16_9,
  ASPECT_RATIO_1_1,
  ASPECT_RATIO_4_5,
  BUSINESS_OFFERING_PHYSICAL_PRODUCT_PLACEHOLDER,
  BUSINESS_OFFERING_SERVICES_PLACEHOLDER,
  FILTERS_GALLERY_IMAGE,
  FILTERS_GALLERY_VIDEO,
  FILTERS_GALLERY_HORIZONTAL,
  FILTERS_GALLERY_VERTICAL,
  FILTERS_GALLERY_SQUARE,
  FILTERS_GALLERY_TODAY,
  FILTERS_GALLERY_WEEK,
  FILTERS_GALLERY_MONTH,
  FILTERS_GALLERY_YEAR,
  GALLERY_CONTENT_TYPE,
  GALLERY_DIMENSIONS,
  GALLERY_DATE_RANGE,
  CARD_GET_CAMPAIGN_LEARNINGS,
  CARD_GET_CAMPAIGN_LEARNINGS_DESCRIPTION,
  CARD_GET_CAMPAIGN_LEARNINGS_QUESTION,
  CARD_OPTIMIZE_GENERAL,
  CARD_OPTIMIZE_GENERAL_DESCRIPTION,
  CARD_MANAGE_BUDGET,
  CARD_MANAGE_BUDGET_DESCRIPTION,
  CARD_OPTIMIZE_GENERAL_QUESTION,
  CARD_MANAGE_BUDGET_QUESTION,
  MODAL_UPLOAD_INSTAGRAM_TYPE_POST_LABEL,
  MODAL_UPLOAD_INSTAGRAM_TYPE_STORY_LABEL,
  MODAL_UPLOAD_INSTAGRAM_TYPE_REEL_LABEL,
  ALERT_AD_ACCOUNT_STATUS_DISABLED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_UNSETTLED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_RISK_REVIEW_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_SETTLEMENT_LABEL,
  ALERT_AD_ACCOUNT_STATUS_IN_GRACE_PERIOD_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_CLOSURE_LABEL,
  ALERT_AD_ACCOUNT_STATUS_CLOSED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_ANY_CLOSED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_LIMITED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_REVIEW_FAILED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_REVIEW_FAILED_FINAL_LABEL,
  ALERT_AD_ACCOUNT_STATUS_MODIFY_REVIEW_FAILED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_REVIEW_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_VERIFICATION_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_MODIFY_REVIEW_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_CRM_REVIEW_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_PUBLIC_AUTH_LABEL,
  ALERT_AD_ACCOUNT_STATUS_PENDING_QUALIFICATION_LABEL,
  ALERT_AD_ACCOUNT_STATUS_CONTRACT_PENDING_LABEL,
  ALERT_AD_ACCOUNT_STATUS_DRAFT_LABEL,
  ALERT_AD_ACCOUNT_STATUS_BILLING_HOLD_LABEL,
  ALERT_AD_ACCOUNT_STATUS_TOTAL_BUDGET_HOLD_LABEL,
  ALERT_AD_ACCOUNT_STATUS_END_DATE_HOLD_LABEL,
  ALERT_AD_ACCOUNT_STATUS_RESTRICTED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_INTERNAL_HOLD_LABEL,
  ALERT_AD_ACCOUNT_STATUS_STOPPED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_SUSPENDED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_CANCELED_LABEL,
  ALERT_AD_ACCOUNT_STATUS_BILLING_PENDING_LABEL,
  ALERT_AD_ACCOUNT_STATUS_BILLING_CANCELLED_LABEL,
  ALERT_AD_ACCOUNT_NO_BALANCE_LABEL,
  ALERT_MERCHANT_NO_ELIGIBLE_PRODUCTS_LABEL,
  ALERT_MERCHANT_PRODUCTS_PARTIAL_ISSUES_LABEL,
  ALERT_MARKETING_OBJECTIVE_GOOGLE_NOT_SET_LABEL,
  ALERT_AD_CPA_LOW_LABEL,
  ALERT_AD_CPA_MEDIUM_LABEL,
  ALERT_AD_CPA_HIGH_LABEL,
  ALERT_ASSET_GROUP_CPA_LOW_LABEL,
  ALERT_ASSET_GROUP_CPA_MEDIUM_LABEL,
  ALERT_ASSET_GROUP_CPA_HIGH_LABEL,
  ALERT_AD_GROUP_CPA_LOW_LABEL,
  ALERT_AD_GROUP_CPA_MEDIUM_LABEL,
  ALERT_AD_GROUP_CPA_HIGH_LABEL,
  ALERT_AD_CPA_LOW_TABLE_LABEL,
  ALERT_AD_CPA_MEDIUM_TABLE_LABEL,
  ALERT_AD_CPA_HIGH_TABLE_LABEL,
  ALERT_ASSET_GROUP_CPA_LOW_TABLE_LABEL,
  ALERT_ASSET_GROUP_CPA_MEDIUM_TABLE_LABEL,
  ALERT_ASSET_GROUP_CPA_HIGH_TABLE_LABEL,
  ALERT_AD_GROUP_CPA_LOW_TABLE_LABEL,
  ALERT_AD_GROUP_CPA_MEDIUM_TABLE_LABEL,
  ALERT_AD_GROUP_CPA_HIGH_TABLE_LABEL,
  ALERT_CREATIVE_FATIGUE_MEDIUM_LABEL,
  ALERT_CREATIVE_FATIGUE_HIGH_LABEL,
  ALERT_CREATIVE_FATIGUE_MEDIUM_TABLE_LABEL,
  ALERT_CREATIVE_FATIGUE_HIGH_TABLE_LABEL,
  INACTIVE,
  ACTIVE,
  TRACKING_CUSTOM_EVENT_ID_LINKEDIN_PLACEHOLDER,
  AD_ACCOUNT_LINKEDIN_PLACEHOLDER,
  TRACKING_LINKEDIN_ID_PLACEHOLDER,
  CARD_GENERATE_COPY,
  CARD_GENERATE_COPY_DESCRIPTION,
  CARD_GENERATE_COPY_QUESTION,
  CAMPAIGN_AGENT_CARD_LEARNINGS_TITLE,
  CAMPAIGN_AGENT_CARD_LEARNINGS_DESCRIPTION,
  CAMPAIGN_AGENT_CARD_LEARNINGS_QUESTION,
  CAMPAIGN_AGENT_CARD_IMPROVE_TITLE,
  CAMPAIGN_AGENT_CARD_IMPROVE_DESCRIPTION,
  CAMPAIGN_AGENT_CARD_IMPROVE_QUESTION,
  CAMPAIGN_AGENT_CARD_BUDGET_TITLE,
  CAMPAIGN_AGENT_CARD_BUDGET_DESCRIPTION,
  CAMPAIGN_AGENT_CARD_BUDGET_QUESTION,
  CAMPAIGN_AGENT_CARD_COPY_TITLE,
  CAMPAIGN_AGENT_CARD_COPY_DESCRIPTION,
  CAMPAIGN_AGENT_CARD_COPY_QUESTION,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_1,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_2,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_3,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_4,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_5,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_6,
  CAMPAIGN_AGENT_FOLLOW_UP_MORE_TITLE,
  CAMPAIGN_AGENT_FOLLOW_UP_MORE_MESSAGE,
  CAMPAIGN_AGENT_FOLLOW_UP_BUDGET_TITLE,
  CAMPAIGN_AGENT_FOLLOW_UP_COPY_TITLE,
  YOUTUBE_PRIVACY_LEVEL_PUBLIC,
  YOUTUBE_PRIVACY_LEVEL_UNLISTED,
  YOUTUBE_PRIVACY_LEVEL_PRIVATE,
  MODAL_UPLOAD_FACEBOOK_TYPE_POST_LABEL,
  MODAL_UPLOAD_FACEBOOK_TYPE_STORY_LABEL,
  MODAL_UPLOAD_FACEBOOK_TYPE_REEL_LABEL,
  MODAL_UPLOAD_TIKTOK_TYPE_POST_LABEL,
  CONTENT_TYPE_CAROUSEL,
  FILTERS_GALLERY_CAROUSEL,
  MONTHLY,
  YEARLY,
  MODAL_CANVA_IMAGE_CONFIG_TITLE,
  MODAL_CANVA_IMAGE_CONFIG_DESCRIPTION,
  MODAL_CANVA_IMAGE_CONFIG_CREATE_BUTTON,
  MODAL_CANVA_IMAGE_CONFIG_EDIT_TITLE,
  MODAL_CANVA_IMAGE_CONFIG_EDIT_DESCRIPTION,
  MODAL_CANVA_IMAGE_CONFIG_EDIT_BUTTON,
  MODAL_CANVA_DISCONNECT_TITLE,
  MODAL_CANVA_DISCONNECT_DESCRIPTION,
  MODAL_CANVA_DISCONNECT_BUTTON,
  ALL,
  COUNTRY_ANDORRA,
  COUNTRY_UNITED_ARAB_EMIRATES,
  COUNTRY_AFGHANISTAN,
  COUNTRY_ANTIGUA_AND_BARBUDA,
  COUNTRY_ANGUILLA,
  COUNTRY_ALBANIA,
  COUNTRY_ARMENIA,
  COUNTRY_ANGOLA,
  COUNTRY_ANTARCTICA,
  COUNTRY_ARGENTINA,
  COUNTRY_AMERICAN_SAMOA,
  COUNTRY_AUSTRIA,
  COUNTRY_AUSTRALIA,
  COUNTRY_ARUBA,
  COUNTRY_ALLAND_ISLANDS,
  COUNTRY_AZERBAIJAN,
  COUNTRY_BOSNIA_AND_HERZEGOVINA,
  COUNTRY_BARBADOS,
  COUNTRY_BANGLADESH,
  COUNTRY_BELGIUM,
  COUNTRY_BURKINA_FASO,
  COUNTRY_BULGARIA,
  COUNTRY_BAHRAIN,
  COUNTRY_BURUNDI,
  COUNTRY_BENIN,
  COUNTRY_SAINT_BARTHELEMY,
  COUNTRY_BERMUDA,
  COUNTRY_BRUNEI_DARUSSALAM,
  COUNTRY_BOLIVIA,
  COUNTRY_BRAZIL,
  COUNTRY_BAHAMAS,
  COUNTRY_BHUTAN,
  COUNTRY_BOUVET_ISLAND,
  COUNTRY_BOTSWANA,
  COUNTRY_BELARUS,
  COUNTRY_BELIZE,
  COUNTRY_CANADA,
  COUNTRY_COCOS_KEELING_ISLANDS,
  COUNTRY_CONGO_DEMOCRATIC_REPUBLIC_OF_THE,
  COUNTRY_CENTRAL_AFRICAN_REPUBLIC,
  COUNTRY_CONGO_REPUBLIC_OF_THE,
  COUNTRY_SWITZERLAND,
  COUNTRY_COTE_D_IVOIRE,
  COUNTRY_COOK_ISLANDS,
  COUNTRY_CHILE,
  COUNTRY_CAMEROON,
  COUNTRY_CHINA,
  COUNTRY_COLOMBIA,
  COUNTRY_COSTA_RICA,
  COUNTRY_CUBA,
  COUNTRY_CAPE_VERDE,
  COUNTRY_CURACAO,
  COUNTRY_CHRISTMAS_ISLAND,
  COUNTRY_CYPRUS,
  COUNTRY_CZECH_REPUBLIC,
  COUNTRY_GERMANY,
  COUNTRY_DJIBOUTI,
  COUNTRY_DENMARK,
  COUNTRY_DOMINICA,
  COUNTRY_DOMINICAN_REPUBLIC,
  COUNTRY_ALGERIA,
  COUNTRY_ECUADOR,
  COUNTRY_ESTONIA,
  COUNTRY_EGYPT,
  COUNTRY_WESTERN_SAHARA,
  COUNTRY_ERITREA,
  COUNTRY_SPAIN,
  COUNTRY_ETHIOPIA,
  COUNTRY_FINLAND,
  COUNTRY_FIJI,
  COUNTRY_FALKLAND_ISLANDS_MALVINAS,
  COUNTRY_MICRONESIA_FEDERATED_STATES_OF,
  COUNTRY_FAROE_ISLANDS,
  COUNTRY_FRANCE,
  COUNTRY_GABON,
  COUNTRY_UNITED_KINGDOM,
  COUNTRY_GRENADA,
  COUNTRY_GEORGIA,
  COUNTRY_FRENCH_GUIANA,
  COUNTRY_GUERNSEY,
  COUNTRY_GHANA,
  COUNTRY_GIBRALTAR,
  COUNTRY_GREENLAND,
  COUNTRY_GAMBIA,
  COUNTRY_GUINEA,
  COUNTRY_GUADELOUPE,
  COUNTRY_EQUATORIAL_GUINEA,
  COUNTRY_GREECE,
  COUNTRY_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
  COUNTRY_GUATEMALA,
  COUNTRY_GUAM,
  COUNTRY_GUINEA_BISSAU,
  COUNTRY_GUYANA,
  COUNTRY_HONG_KONG,
  COUNTRY_HEARD_ISLAND_AND_MCDONALD_ISLANDS,
  COUNTRY_HONDURAS,
  COUNTRY_CROATIA,
  COUNTRY_HAITI,
  COUNTRY_HUNGARY,
  COUNTRY_INDONESIA,
  COUNTRY_IRELAND,
  COUNTRY_ISRAEL,
  COUNTRY_ISLE_OF_MAN,
  COUNTRY_INDIA,
  COUNTRY_BRITISH_INDIAN_OCEAN_TERRITORY,
  COUNTRY_IRAQ,
  COUNTRY_IRAN_ISLAMIC_REPUBLIC_OF,
  COUNTRY_ICELAND,
  COUNTRY_ITALY,
  COUNTRY_JERSEY,
  COUNTRY_JAMAICA,
  COUNTRY_JORDAN,
  COUNTRY_JAPAN,
  COUNTRY_KENYA,
  COUNTRY_KYRGYZSTAN,
  COUNTRY_CAMBODIA,
  COUNTRY_KIRIBATI,
  COUNTRY_COMOROS,
  COUNTRY_SAINT_KITTS_AND_NEVIS,
  COUNTRY_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF,
  COUNTRY_KOREA_REPUBLIC_OF,
  COUNTRY_KUWAIT,
  COUNTRY_CAYMAN_ISLANDS,
  COUNTRY_KAZAKHSTAN,
  COUNTRY_LAO_PEOPLES_DEMOCRATIC_REPUBLIC,
  COUNTRY_LEBANON,
  COUNTRY_SAINT_LUCIA,
  COUNTRY_LIECHTENSTEIN,
  COUNTRY_SRI_LANKA,
  COUNTRY_LIBERIA,
  COUNTRY_LESOTHO,
  COUNTRY_LITHUANIA,
  COUNTRY_LUXEMBOURG,
  COUNTRY_LATVIA,
  COUNTRY_LIBYA,
  COUNTRY_MOROCCO,
  COUNTRY_MONACO,
  COUNTRY_MOLDOVA_REPUBLIC_OF,
  COUNTRY_MONTENEGRO,
  COUNTRY_SAINT_MARTIN_FRENCH_PART,
  COUNTRY_MADAGASCAR,
  COUNTRY_MARSHALL_ISLANDS,
  COUNTRY_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF,
  COUNTRY_MALI,
  COUNTRY_MYANMAR,
  COUNTRY_MONGOLIA,
  COUNTRY_MACAO,
  COUNTRY_NORTHERN_MARIANA_ISLANDS,
  COUNTRY_MARTINIQUE,
  COUNTRY_MAURITANIA,
  COUNTRY_MONTSERRAT,
  COUNTRY_MALTA,
  COUNTRY_MAURITIUS,
  COUNTRY_MALDIVES,
  COUNTRY_MALAWI,
  COUNTRY_MEXICO,
  COUNTRY_MALAYSIA,
  COUNTRY_MOZAMBIQUE,
  COUNTRY_NAMIBIA,
  COUNTRY_NEW_CALEDONIA,
  COUNTRY_NIGER,
  COUNTRY_NORFOLK_ISLAND,
  COUNTRY_NIGERIA,
  COUNTRY_NICARAGUA,
  COUNTRY_NETHERLANDS,
  COUNTRY_NORWAY,
  COUNTRY_NEPAL,
  COUNTRY_NAURU,
  COUNTRY_NIUE,
  COUNTRY_NEW_ZEALAND,
  COUNTRY_OMAN,
  COUNTRY_PANAMA,
  COUNTRY_PERU,
  COUNTRY_FRENCH_POLYNESIA,
  COUNTRY_PAPUA_NEW_GUINEA,
  COUNTRY_PHILIPPINES,
  COUNTRY_PAKISTAN,
  COUNTRY_POLAND,
  COUNTRY_SAINT_PIERRE_AND_MIQUELON,
  COUNTRY_PITCAIRN,
  COUNTRY_PUERTO_RICO,
  COUNTRY_PALESTINE_STATE_OF,
  COUNTRY_PORTUGAL,
  COUNTRY_PALAU,
  COUNTRY_PARAGUAY,
  COUNTRY_QATAR,
  COUNTRY_REUNION,
  COUNTRY_ROMANIA,
  COUNTRY_SERBIA,
  COUNTRY_RUSSIAN_FEDERATION,
  COUNTRY_RWANDA,
  COUNTRY_SAUDI_ARABIA,
  COUNTRY_SOLOMON_ISLANDS,
  COUNTRY_SEYCHELLES,
  COUNTRY_SUDAN,
  COUNTRY_SWEDEN,
  COUNTRY_SINGAPORE,
  COUNTRY_SAINT_HELENA,
  COUNTRY_SLOVENIA,
  COUNTRY_SVALBARD_AND_JAN_MAYEN,
  COUNTRY_SLOVAKIA,
  COUNTRY_SIERRA_LEONE,
  COUNTRY_SAN_MARINO,
  COUNTRY_SENEGAL,
  COUNTRY_SOMALIA,
  COUNTRY_SURINAME,
  COUNTRY_SOUTH_SUDAN,
  COUNTRY_SAO_TOME_AND_PRINCIPE,
  COUNTRY_EL_SALVADOR,
  COUNTRY_SINT_MAARTEN_DUTCH_PART,
  COUNTRY_SYRIAN_ARAB_REPUBLIC,
  COUNTRY_SWAZILAND,
  COUNTRY_TURKS_AND_CAICOS_ISLANDS,
  COUNTRY_CHAD,
  COUNTRY_FRENCH_SOUTHERN_TERRITORIES,
  COUNTRY_TOGO,
  COUNTRY_THAILAND,
  COUNTRY_TAJIKISTAN,
  COUNTRY_TOKELAU,
  COUNTRY_TIMOR_LESTE,
  COUNTRY_TURKMENISTAN,
  COUNTRY_TUNISIA,
  COUNTRY_TONGA,
  COUNTRY_TURKEY,
  COUNTRY_TRINIDAD_AND_TOBAGO,
  COUNTRY_TUVALU,
  COUNTRY_TAIWAN,
  COUNTRY_UNITED_REPUBLIC_OF_TANZANIA,
  COUNTRY_UKRAINE,
  COUNTRY_UGANDA,
  COUNTRY_UNITED_STATES,
  COUNTRY_URUGUAY,
  COUNTRY_UZBEKISTAN,
  COUNTRY_HOLY_SEE_VATICAN_CITY_STATE,
  COUNTRY_SAINT_VINCENT_AND_THE_GRENADINES,
  COUNTRY_VENEZUELA,
  COUNTRY_BRITISH_VIRGIN_ISLANDS,
  COUNTRY_US_VIRGIN_ISLANDS,
  COUNTRY_VIETNAM,
  COUNTRY_VANUATU,
  COUNTRY_WALLIS_AND_FUTUNA,
  COUNTRY_SAMOA,
  COUNTRY_KOSOVO,
  COUNTRY_YEMEN,
  COUNTRY_MAYOTTE,
  COUNTRY_SOUTH_AFRICA,
  COUNTRY_ZAMBIA,
  COUNTRY_ZIMBABWE,
  ALERT_AD_ACCOUNT_STATUS_UNSETTLED_PREPAY_LABEL,
  FILTERS_GALLERY_FEED,
} from "../i18n/keysTranslations";
import {
  ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_INSTANT_FORM_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION,
  GOOGLE,
  LINKEDIN,
  META,
  TIKTOK,
} from "./adsPlatformIds.js";
import { MAIN_COLOR_META, MAIN_COLOR_META_TEXT } from "./colors";
import { logoPlatform } from "./string";
import { FileText, DollarSign, Lightbulb, BookOpen } from "lucide-react";
import {
  DATE_RANGE_PRESET_TODAY,
  DATE_RANGE_PRESET_YESTERDAY,
  DATE_RANGE_PRESET_LAST_7,
  DATE_RANGE_PRESET_LAST_14,
  DATE_RANGE_PRESET_LAST_30,
  DATE_RANGE_PRESET_THIS_WEEK,
  DATE_RANGE_PRESET_LAST_WEEK,
  DATE_RANGE_PRESET_THIS_MONTH,
  DATE_RANGE_PRESET_LAST_MONTH,
  DATE_RANGE_PRESET_THIS_YEAR,
  DATE_RANGE_PRESET_LAST_YEAR,
  DATE_RANGE_PRESET_CUSTOM,
} from "../i18n/keysTranslations";
import {
  PRE_ACTIVATION_SALES_CHANNEL_TIENDA_WEB,
  PRE_ACTIVATION_SALES_CHANNEL_TIENDA_FISICA,
  PRE_ACTIVATION_SALES_CHANNEL_WHATSAPP,
  PRE_ACTIVATION_SALES_CHANNEL_MARKETPLACE,
  PRE_ACTIVATION_SALES_CHANNEL_APP,
  PRE_ACTIVATION_HAS_ADS_SI,
  PRE_ACTIVATION_HAS_ADS_ANTES,
  PRE_ACTIVATION_HAS_ADS_NO,
  PRE_ACTIVATION_ADS_PLATFORM_META,
  PRE_ACTIVATION_ADS_PLATFORM_GOOGLE,
  PRE_ACTIVATION_ADS_PLATFORM_TIKTOK,
  PRE_ACTIVATION_ADS_PLATFORM_LINKEDIN,
  PRE_ACTIVATION_ADS_PLATFORM_OTHER,
  PRE_ACTIVATION_BUZZLY_FOCUS_PERFORMANCE,
  PRE_ACTIVATION_BUZZLY_FOCUS_CONTENIDO,
  PRE_ACTIVATION_BUZZLY_FOCUS_AMBOS,
  PRE_ACTIVATION_CREATIVE_MATERIAL_SI_MUCHO,
  PRE_ACTIVATION_CREATIVE_MATERIAL_SI_POCO,
  PRE_ACTIVATION_CREATIVE_MATERIAL_NO_IA,
  PRE_ACTIVATION_MEETING_ACCESS_META_BM,
  PRE_ACTIVATION_MEETING_ACCESS_GOOGLE_ADS,
  PRE_ACTIVATION_MEETING_ACCESS_TIKTOK_ADS,
  PRE_ACTIVATION_MEETING_ACCESS_GA4,
  PRE_ACTIVATION_MEETING_ACCESS_PIXEL,
  PRE_ACTIVATION_MEETING_ACCESS_GTM,
  PRE_ACTIVATION_ORGANIZATION_TYPE_AGENCY_LABEL,
  PRE_ACTIVATION_ORGANIZATION_TYPE_BRAND_LABEL,
  PRE_ACTIVATION_OPTION_YES,
  PRE_ACTIVATION_OPTION_NO,
  PRE_ACTIVATION_BEFORE_START_TIP_1_TITLE,
  PRE_ACTIVATION_BEFORE_START_TIP_1_DESCRIPTION,
  PRE_ACTIVATION_BEFORE_START_TIP_2_TITLE,
  PRE_ACTIVATION_BEFORE_START_TIP_2_DESCRIPTION,
  PRE_ACTIVATION_BEFORE_START_TIP_3_TITLE,
  PRE_ACTIVATION_BEFORE_START_TIP_3_DESCRIPTION,
  PRE_ACTIVATION_BEFORE_START_TIP_4_TITLE,
  PRE_ACTIVATION_BEFORE_START_TIP_4_DESCRIPTION,
  PRE_ACTIVATION_BEFORE_START_TIP_5_TITLE,
  PRE_ACTIVATION_BEFORE_START_TIP_5_DESCRIPTION,
  ENTERPRISE_INTAKE_OTHER_OPTION,
  ENTERPRISE_INTAKE_MODULE_CREATIVE_ASSETS,
  ENTERPRISE_INTAKE_MODULE_PAID_MEDIA_LAUNCH,
  ENTERPRISE_INTAKE_MODULE_PAID_MEDIA_IMPORT,
  ENTERPRISE_INTAKE_MODULE_REPORTS,
  ENTERPRISE_INTAKE_MODULE_COMPETITORS,
  ENTERPRISE_INTAKE_MODULE_ORGANIC_SOCIAL,
  ENTERPRISE_INTAKE_BUFFER_STATICS,
  ENTERPRISE_INTAKE_BUFFER_ANIMATIONS,
  ENTERPRISE_INTAKE_BUFFER_VIDEOS,
  ENTERPRISE_INTAKE_BUFFER_NONE,
  ENTERPRISE_INTAKE_BUFFER_PERCENT_10,
  ENTERPRISE_INTAKE_BUFFER_PERCENT_15,
  ENTERPRISE_INTAKE_BUFFER_PERCENT_20,
  ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_LOW,
  ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_MEDIUM,
  ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_HIGH,
  ENTERPRISE_INTAKE_CONTRACT_TERM_6,
  ENTERPRISE_INTAKE_CONTRACT_TERM_12,
  ENTERPRISE_INTAKE_MEDIA_ADDON_YES,
  ENTERPRISE_INTAKE_MEDIA_ADDON_NO,
  ENTERPRISE_INTAKE_WHITE_LABEL_YES,
  ENTERPRISE_INTAKE_WHITE_LABEL_NO,
  OPTION_EMAIL,
  OPTION_GOOGLE,
  OPTION_LINKEDIN,
  OPTION_LLM,
  OPTION_META,
  OPTION_OTHER,
  MODAL_CREATE_WITH_IA_PLATFORM_DEFAULT,
} from "../i18n/keysTranslations";

export const THEME_ID_PROJECT = import.meta.env.VITE_KEY_THEME_ID_PROJECT;
export const ID_ADLE_THEME = "-O4JAFuzbI9lgr-GbnUV";
export const DEFAULT_NAME_BUSINESS = "Adle";
export const MAX_BUSINESS_COMPETITORS = 5;
export const IS_WHITE_LABEL_BRAND =
  THEME_ID_PROJECT && THEME_ID_PROJECT !== ID_ADLE_THEME;
export const IS_ADLE_DOMAIN = THEME_ID_PROJECT === ID_ADLE_THEME;

export const REBRAND_BANNER_HEIGHT = 40;
export const REBRAND_BANNER_APP_SUMO_CAROUSEL_INTERVAL_MS = 7000;
export const NAVBAR_HEIGHT = 64;

export const getRebrandBannerOffsetPx = ({ showBanner }) =>
  showBanner ? REBRAND_BANNER_HEIGHT : 0;

export const getTotalTopOffsetPx = ({ showBanner }) =>
  NAVBAR_HEIGHT + getRebrandBannerOffsetPx({ showBanner });

export const IS_STAGING = import.meta.env.VITE_IS_STAGING === "true";

export const AGENCIES_WITH_HIDDEN_PREVIOUS_PLANS = [
  "-O4JAFuzbI9lgr-GbnUV",
  "-OjuMjRMcEtNmUwzp2F0",
];

export const ADVERTISERS_DEMO = [
  "-O4JAFuzbI9lgr-GbnUV",
  "-O4JAG2ZQtMQBFBFOQhQ",
  "-O4JAGD_ZD2wT6ElfaT_",
  "-OJUpPhaonqYEh-gd0QZ",
  "-ObbtqtiWy9bHljsvBbI",
  "-ObbtqtiWy9bHljsvBbm",
];

export const ADVERTISER_CANVA = "-O4IsuJUTOyUZujHJwNV";

/**
 * localStorage flag for owner "login as client" support sessions (not a
 * user-initiated login). The legacy value is kept so sessions already flagged
 * keep skipping lastLogins / NPS.
 */
export const PRIVILEGED_LOGIN_STORAGE_KEY = "loginByMasterPassword";
// slideMenuCollapsedStorage.js keeps a copy of this key. The storage test guards it.
export const SLIDE_MENU_COLLAPSED_STORAGE_KEY = "bz.slideMenuCollapsed.v1";

//STATUS
export const STATES = {
  SCHEDULED: "scheduled",
  PUBLISHED: "published",
  DRAFT: "draft",
  FAILED: "failed",
  SKIPPED: "skipped",
};

//SOCIAL NETWORKS
export const INSTAGRAM = "instagram";
export const FACEBOOK = "facebook";
export {
  ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_INSTANT_FORM_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION,
  GOOGLE,
  LINKEDIN,
  META,
  TIKTOK,
};
export const META_WHITE = "metaWhite";
export const TIKTOK_CREDIT_PERCENTAGE = "4%";
export const TIKTOK_BUSINESS = "tiktokBusiness";
export const TIKTOK_SHARE = "tiktok";
export const YOUTUBE = "youtube";

export const YOUTUBE_VIDEO_SOURCE = {
  youtube: "youtube",
  gallery: "gallery",
  url: "url",
};
export const INSTAGRAM_WHITE = "instagramWhite";
export const CANVA = "canva";
export const GOOGLE_DRIVE = "googleDrive";
export const VIDEO_GENERATION_STATUS = "videoGeneration";
export const IMAGE_GENERATION_STATUS = "imageGeneration";
export const CAMPAIGN_GENERATION_STATUS = "campaignGeneration";
export const ORGANIC = "organic";

export const LINKEDIN_PUBLISH_AS = {
  ORGANIZATION: "ORGANIZATION",
  PROFILE: "PROFILE",
};

/** Entity keys for Cloud Function getAdsAccountsEntities (must match backend). */
export const ADS_INTEGRATION_ENTITIES = {
  AD_ACCOUNTS: "adAccounts",
  PAGES: "pages",
};

export const X = "x";
export const THREADS = "threads";

export const MODE_BACK_DROP_CONNECT = {
  GET_INFORMATION: "getInformation",
  GET_POPUP: "getPopup",
  GOOGLE_DRIVE_CONFIGURING: "googleDriveConfiguring",
  GOOGLE_DRIVE_IMPORTING: "googleDriveImporting",
};

export const PLATFORMS_WITH_END_DATE_IN_ADGROUP = [META, TIKTOK];

export const BORDER_RADIUS = 4;
export const BORDER_RADIUS_BUTTON = 6;
export const FONT_SIZE_BUTTON = 12;
export const FONT_WEIGHT_BUTTON = 500;
export const HEIGHT_BUTTON = 48;
export const FONT_FAMILY = "Inter";
export const DRAWER_WIDTH = 220;
export const DRAWER_WIDTH_COLLAPSED = 80;
export const DRAWER_CAMPAIGN = DRAWER_WIDTH + 50;
export const MIN_WIDTH_SCREEN_TO_SHOW_CHAT = 1400;
export const PADDING_DESKTOP = 2;
export const PADDING_MOBILE = 1.5;
//ROLES
export const ADVERTISER_ROLE = "advertiser";
export const MARKETER_ROLE = "marketer";
export const VIEWER_ROLE = "viewer";
export const SUPER_ADMIN_ROLE = "superAdmin";
export const ADMIN_ROLE = "admin";
export const DESIGNER_ROLE = "designer";
export const OWNER_ROLE = "owner";
export const ROLES_SHOPS = [ADMIN_ROLE, OWNER_ROLE];
export const ROLES_PLATFORMS = [
  ADVERTISER_ROLE,
  MARKETER_ROLE,
  VIEWER_ROLE,
  DESIGNER_ROLE,
  OWNER_ROLE,
  SUPER_ADMIN_ROLE,
];

export const ROLES_CHANGE_PASSWORD = [
  MARKETER_ROLE,
  DESIGNER_ROLE,
  VIEWER_ROLE,
];

export const ROLES_ALLOWED = [...ROLES_PLATFORMS, ...ROLES_SHOPS];

export const SOCIAL_NETWORKS_DOMAINS_SUPPORTED_SCRAPPING = [
  "instagram.com",
  "tiktok.com",
];

export const ADS_OBJECT_TYPES = {
  campaign: "campaign",
  adGroup: "adGroup",
  ad: "ad",
  assetsGroup: "assetsGroup",
  insight: "insight",
};
export const ADS_KEYS_TEXT = [
  "titles",
  "descriptions",
  "headlines",
  "longHeadlines",
  "callOuts",
  "destinationUrls",
];
export const ADS_KEYS_CREATIVES = ["mediaUrls", "imageUrls", "videoUrls"];

export const DEFAULT_TABLE_PAGES = 50;
export const GB_IN_BYTES = 1024 * 1024 * 1024;

export const MAX_GB_STORAGE = 1;
export const MAX_BYTES_STORAGE = MAX_GB_STORAGE * 1024 ** 3;

export const getReferenceAdStoragePath = (userID) =>
  userID ? `referenceAds/${userID}/` : "";

export const RECURRENT_MULTIPLIER = {
  monthly: 1,
  quarterly: 3,
  semiyearly: 6,
  yearly: 12,
};

export const RECURRENT_TYPES = {
  monthly: "monthly",
  quarterly: "quarterly",
  semiyearly: "semiyearly",
  yearly: "yearly",
};

export const RECURRENT = {
  monthly: MONTHLY,
  yearly: YEARLY,
};

export const ADLE_DOMAIN = "adle.ai";
export const BUZZLY_DOMAIN = "heybuzzly.ai";
export const BRANDS_BLOCKED = {
  sedilec: "sedilec",
};

//PLANS
export const PLAN_BASIC = "basic";
export const PLAN_STARTER = "starter";
export const PLAN_GROWTH = "growth";
export const PLAN_ADVANCED = "advanced";
export const PLAN_PRO = "pro";
export const PLAN_STUDIO = "studio";
export const PLAN_AGENCY = "agency";
export const PLAN_ENTERPRISE = "enterprise";
export const ALL_PLANS = [
  PLAN_BASIC,
  PLAN_STARTER,
  PLAN_GROWTH,
  PLAN_ADVANCED,
  PLAN_PRO,
  PLAN_STUDIO,
  PLAN_AGENCY,
  PLAN_ENTERPRISE,
];
export const CURRENT_PLANS = [
  PLAN_STARTER,
  PLAN_STUDIO,
  PLAN_AGENCY,
  PLAN_ENTERPRISE,
];
export const LEGACY_CURRENT_PLANS = [
  PLAN_BASIC,
  PLAN_STARTER,
  PLAN_PRO,
  PLAN_ENTERPRISE,
];

// PLAN TYPES
export const PLAN_TYPE_PACKAGES = "packages";
export const PLAN_TYPE_CREDITS = "credits";

export const SUBSCRIPTION_PAYWALL_REASONS = {
  INSUFFICIENT_CREDITS: "insufficientCredits",
};

export const PLAN_TYPES = [PLAN_TYPE_PACKAGES, PLAN_TYPE_CREDITS];

export const MIN_CREDITS_TO_ADD = 1;
export const MAX_CREDITS_TO_ADD = 50;

//CREATE BRAND
export const PLAN_TYPES_OPTIONS = [
  // {
  //   label: "Packages",
  //   value: PLAN_TYPE_PACKAGES,
  // },
  {
    label: "Credits",
    value: PLAN_TYPE_CREDITS,
  },
];

export const PLAN_RECURRENT_OPTIONS = [
  {
    label: MONTHLY,
    value: RECURRENT_TYPES.monthly,
  },
  {
    label: YEARLY,
    value: RECURRENT_TYPES.yearly,
  },
];

/** Planes para select (sin enterprise), value = plan string, label = capitalizado */
export const PLAN_OPTIONS_FOR_SELECT = CURRENT_PLANS.filter(
  (p) => p !== PLAN_ENTERPRISE
).map((plan) => ({
  value: plan,
  label: plan.charAt(0).toUpperCase() + plan.slice(1),
}));

//CREDITS
export const CREDITS_OPTIONS = [20, 50, 100, 200];
export const CREDITS_REWARD_LINKEDIN_ARTICLE = 20;

export const ADLE_APP_BASE_URL = "https://app.adle.ai";
export const EMAIL_SUPPORT = "info@adle.ai";
export const LINK_TO_WHATSAPP_SUPPORT_PRICES =
  "https://api.whatsapp.com/send?phone=573102246494&text=Estoy%20interesado%20en%20suscribirme%20a%20";
export const LINK_LANDING_CONTACT = "https://adle.ai/contact";
export const LINK_ADLE_DISCORD = "https://discord.gg/rugS2NCGSX";
export const LINK_ADLE_AFFILIATE = "https://adle.ai/affiliate";
export const LINK_BOOK_DEMO_VIDEO_EN = "https://youtu.be/3u3uJ9DkmwM";
export const LINK_BOOK_DEMO_VIDEO_ES = "https://youtu.be/agjXtKaPpVc";
export const LINK_APPSUMO_ADLE =
  "https://appsumo.com/products/adle-ai#pricePlans";
export const LINK_APPSUMO_ADLE_REVIEWS_NEW =
  "https://appsumo.com/products/adle-ai/reviews/new";
export const LINK_APPSUMO_PRODUCTS = "https://appsumo.com/account/products/";
export const APPSUMO = "APPSUMO";
export const LINK_TO_BOOK_A_DEMO =
  "https://tidycal.com/buzzly-team/buzzly-demo";

export const PLACE_HOLDER_IMAGE =
  "https://clapp-prod.s3.amazonaws.com/ClappIn/place-holder-product.jpeg";
export const PLACE_HOLDER_PERSON_ICON =
  "https://clapp-prod.s3.amazonaws.com/ClappIn/person-icon-default.png";

export const companyInformation = {
  name: "Clapp Technologies, LLC",
  ein: "EIN 36-5040962",
  cp: "CP 575/576",
  address: "651 N Broad St, Middletown, New Castle, DE, 19709 United States",
  email: "info@adle.ai",
  phone: "(+57) 3009711909",
};

// OMIT CAMPAIGNS - Exclude specific advertiser campaigns from agency count
export const OMIT_CAMPAIGNS_FROM_SPECIFIC_ADVERTISER_FROM_AGENCY_COUNT = {
  "-OMh44spqTPqI4nORwL3": ["-OMh44spqTPqI4nORwL8"],
};

// ALERTS
export const ALERT_ICON_TYPE_SUCCESS = "success";
export const ALERT_ICON_TYPE_ERROR = "error";
export const ALERT_ICON_TYPE_INFO = "info";
export const ALERT_ICON_TYPE_WARNING = "warning";

// ADS CAMPAIGNS
export const ADS_CAMPAIGN_FORM_MODE_SIMPLE = "simple";
export const ADS_CAMPAIGN_FORM_MODE_ADVANCED = "advanced";
export const ADS_CAMPAIGN_STATUS_DRAFT = "draft";
export const ADS_CAMPAIGN_STATUS_ACTIVE = "active";
export const ADS_CAMPAIGN_STATUS_DEACTIVATED = "deactivated";
export const ADS_CAMPAIGN_STATUS_FINISHED = "finished";
export const ADS_CAMPAIGN_STATUS_DELETED = "deleted";
export const ADS_CAMPAIGN_STATUS = [
  ADS_CAMPAIGN_STATUS_DRAFT,
  ADS_CAMPAIGN_STATUS_ACTIVE,
  ADS_CAMPAIGN_STATUS_DEACTIVATED,
  ADS_CAMPAIGN_STATUS_FINISHED,
];

// SORTING CONFIGURATION
export const SORT_DIRECTION = {
  ASC: "asc",
  DESC: "desc",
};

export const SORTABLE_COLUMNS = {
  CAMPAIGN: "campaign",
  PLATFORM: "platform",
  CREATED_BY: "createdBy",
  CREATION_TIME: "creationTime",
  IMPRESSIONS: "impressions",
  CLICKS: "click",
  CTR: "ctr",
  SPEND: "spend",
  ROAS: "roas",
  CPM: "cpm",
  CPC: "cpc",
  RESULTS: "mainAction",
  CPA: "costPerMainAction",
  FREQUENCY: "frequency",
  STATUS: "status",
};

export const STATUS_SORT_ORDER = {
  [ADS_CAMPAIGN_STATUS_ACTIVE]: 5, // Active
  [ADS_CAMPAIGN_STATUS_DEACTIVATED]: 4, // Deactivated
  [ADS_CAMPAIGN_STATUS_FINISHED]: 3, // Finished
  [ADS_CAMPAIGN_STATUS_DELETED]: 2, // Deleted
  [ADS_CAMPAIGN_STATUS_DRAFT]: 1, // Draft
};

export const REPORTED_CONTENT_STATUSES = {
  REJECTED: "rejected",
  PENDING: "pending",
  APPROVED: "approved",
};

export const DEFAULT_SORT_CONFIG = {
  key: SORTABLE_COLUMNS.CREATION_TIME,
  direction: SORT_DIRECTION.DESC,
};

export const ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION = "awareness";
export const ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION = "traffic";
export const ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION = "engagement";
export const ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION = "appPromotion";
export const ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION = "sales";
export const ADS_CAMPAIGN_OBJECTIVE_VIDEO_VIEWS_OPTION = "videoViews";
export const ADS_CAMPAIGN_OBJECTIVE_WEBSITE_CONVERSIONS_OPTION =
  "websiteConversions";
// Buying Type Options
export const ADS_CAMPAIGN_BUYING_TYPE_AUCTION_OPTION = "AUCTION";
export const ADS_CAMPAIGN_BUYING_TYPE_RESERVED_OPTION = "RESERVED";

export const ADS_CAMPAIGN_CAROUSEL_FORMAT = "carousel";

export const ADS_CAMPAIGN_TYPE_SEARCH_OPTION = "search";
/** Google Search ad group: keyword-based (default when field is missing). */
export const ADS_GOOGLE_SEARCH_AD_GROUP_TYPE_STANDARD_OPTION = "standard";
/** Google Search ad group: Dynamic Search Ads (webpage criteria, no positive keywords). */
export const ADS_GOOGLE_SEARCH_AD_GROUP_TYPE_DSA_OPTION = "dsa";
/** Webpage criterion: full URL must match (maps to Google WebpageCondition). */
export const ADS_GOOGLE_WEBPAGE_CRITERION_URL_EQUALS_OPTION = "EQUALS";
/** Webpage criterion: URL contains substring. */
export const ADS_GOOGLE_WEBPAGE_CRITERION_URL_CONTAINS_OPTION = "url_contains";
export const ADS_GOOGLE_WEBPAGE_CRITERION_VALUE_MAX_LENGTH = 2048;
export const ADS_GOOGLE_WEBPAGE_CRITERIA_MAX_ROWS = 50;

export const ADS_GOOGLE_WEBPAGE_CRITERION_OPERATOR_OPTIONS = [
  ADS_GOOGLE_WEBPAGE_CRITERION_URL_EQUALS_OPTION,
  ADS_GOOGLE_WEBPAGE_CRITERION_URL_CONTAINS_OPTION,
];

/**
 * Resolves Google Search ad group type; missing field means standard keyword ad group.
 * @param {object} adGroup
 * @returns {string}
 */
export const getGoogleSearchAdGroupType = (adGroup) =>
  adGroup?.type || ADS_GOOGLE_SEARCH_AD_GROUP_TYPE_STANDARD_OPTION;

export const ADS_CAMPAIGN_TYPE_PERFORMANCE_MAX_OPTION = "performanceMax";
export const ADS_CAMPAIGN_TYPE_APP_OPTION = "app";
export const GOOGLE_APP_STORE = "GOOGLE_APP_STORE";
export const APPLE_APP_STORE = "APPLE_APP_STORE";
export const ADS_CAMPAIGN_TYPE_SHOPPING_OPTION = "shopping";
export const ADS_CAMPAIGN_TYPE_VIDEO_OPTION = "video";
export const ADS_CAMPAIGN_META_TITLE_MAX_LENGTH = 1500;
export const ADS_CAMPAIGN_TIKTOK_TITLE_MAX_LENGTH = 100;
export const ADS_CAMPAIGN_GOOGLE_TITLE_MAX_LENGTH = 30;
export const ADS_CAMPAIGN_GOOGLE_BUSINESS_NAME_MAX_LENGTH = 25;
export const ADS_CAMPAIGN_META_DESCRIPTION_MAX_LENGTH = 1500;
export const ADS_CAMPAIGN_TIKTOK_DESCRIPTION_MAX_LENGTH = 100;
export const ADS_CAMPAIGN_GOOGLE_DESCRIPTION_MAX_LENGTH = 90;
export const ADS_CAMPAIGN_META_HEADLINE_MAX_LENGTH = 200;
export const ADS_CAMPAIGN_TIKTOK_HEADLINE_MAX_LENGTH = 100;
export const ADS_CAMPAIGN_GOOGLE_HEADLINE_MAX_LENGTH = 100;
export const ADS_CAMPAIGN_GOOGLE_LONG_HEADLINE_MAX_LENGTH = 90;
// LinkedIn specific limits
export const ADS_CAMPAIGN_LINKEDIN_PRIMARY_TEXT_MAX_LENGTH = 3000;
export const ADS_CAMPAIGN_LINKEDIN_HEADLINE_MAX_LENGTH = 200;
export const ADS_CAMPAIGN_LINKEDIN_DESCRIPTION_MAX_LENGTH = 300;
export const ADS_CAMPAIGN_LINKEDIN_CAROUSEL_CARD_HEADLINE_MAX_LENGTH = 45;
export const ADS_CAMPAIGN_LINKEDIN_CAROUSEL_CARD_HEADLINE_LEADS_MAX_LENGTH = 30;
export const ADS_CAMPAIGN_LINKEDIN_CAROUSEL_MIN_CARDS = 2;
export const ADS_CAMPAIGN_LINKEDIN_CAROUSEL_MAX_CARDS = 10;
export const ADS_CAMPAIGN_PLATFORM_TITLE_MAX_LENGTH = {
  [META]: ADS_CAMPAIGN_META_TITLE_MAX_LENGTH,
  [TIKTOK]: ADS_CAMPAIGN_TIKTOK_TITLE_MAX_LENGTH,
  [GOOGLE]: ADS_CAMPAIGN_GOOGLE_TITLE_MAX_LENGTH,
  [LINKEDIN]: ADS_CAMPAIGN_LINKEDIN_PRIMARY_TEXT_MAX_LENGTH,
};
export const ADS_CAMPAIGN_PLATFORM_DESCRIPTION_MAX_LENGTH = {
  [META]: ADS_CAMPAIGN_META_DESCRIPTION_MAX_LENGTH,
  [TIKTOK]: ADS_CAMPAIGN_TIKTOK_DESCRIPTION_MAX_LENGTH,
  [GOOGLE]: ADS_CAMPAIGN_GOOGLE_DESCRIPTION_MAX_LENGTH,
  [LINKEDIN]: ADS_CAMPAIGN_LINKEDIN_DESCRIPTION_MAX_LENGTH,
};
export const ADS_CAMPAIGN_PLATFORM_HEADLINE_MAX_LENGTH = {
  [META]: ADS_CAMPAIGN_META_HEADLINE_MAX_LENGTH,
  [TIKTOK]: ADS_CAMPAIGN_TIKTOK_HEADLINE_MAX_LENGTH,
  [GOOGLE]: ADS_CAMPAIGN_GOOGLE_HEADLINE_MAX_LENGTH,
  [LINKEDIN]: ADS_CAMPAIGN_LINKEDIN_HEADLINE_MAX_LENGTH,
};
export const ADS_CAMPAIGN_PLATFORM_LONG_HEADLINE_MAX_LENGTH = {
  [GOOGLE]: ADS_CAMPAIGN_GOOGLE_LONG_HEADLINE_MAX_LENGTH,
  [LINKEDIN]: ADS_CAMPAIGN_GOOGLE_LONG_HEADLINE_MAX_LENGTH,
};
export const ADS_CAMPAIGN_GOOGLE_FIRST_TITLE_MAX_LENGTH = 15;
export const ADS_CAMPAIGN_GOOGLE_FIRST_DESCRIPTION_MAX_LENGTH = 60;
export const ADS_CAMPAIGN_GOOGLE_MIN_IMAGES_ASSETS_GROUP = 2;
export const ADS_CAMPAIGN_GOOGLE_MAX_IMAGES_ASSETS_GROUP = 20;
export const ADS_CAMPAIGN_GOOGLE_MIN_VIDEOS_ASSETS_GROUP = 0;
export const ADS_CAMPAIGN_GOOGLE_MAX_VIDEOS_ASSETS_GROUP = 15;
export const GOOGLE_PMAX_VIDEO_MIN_DURATION_SECONDS = 10;
export const GOOGLE_PMAX_VIDEO_MAX_DURATION_SECONDS = 60;
export const ADS_CAMPAIGN_GOOGLE_MIN_TITLES = 3;
export const ADS_CAMPAIGN_GOOGLE_MAX_TITLES = 15;
export const ADS_CAMPAIGN_GOOGLE_MIN_DESCRIPTIONS = 2;
export const ADS_CAMPAIGN_GOOGLE_MAX_DESCRIPTIONS = 5;
export const ADS_CAMPAIGN_GOOGLE_MIN_LONG_HEADLINES = 1;
export const ADS_CAMPAIGN_GOOGLE_MAX_LONG_HEADLINES = 5;
export const ADS_CAMPAIGN_GOOGLE_MAX_SEARCH_THEMES = 25;
export const GOOGLE_SEARCH_TERMS_CACHE_TTL_MS = 2 * 60 * 60 * 1000;
export const ADS_CAMPAIGN_GOOGLE_SITE_LINK_NAME_MAX_LENGTH = 25;
export const ADS_CAMPAIGN_GOOGLE_SITE_LINK_DESCRIPTION_MAX_LENGTH = 35;
export const ADS_CAMPAIGN_GOOGLE_CALL_OUT_MAX_LENGTH = 25;
export const ADS_CAMPAIGN_OBJECTIVES_WITH_TRACKING_META = [
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
];
export const ADS_CAMPAIGN_OBJECTIVES_WITH_TRACKING_TIKTOK = [
  ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION,
];

// TikTok Campaign Type (sales objective: website vs app)
export const ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_WEBSITE_OPTION = "website";
export const ADS_CAMPAIGN_TIKTOK_CAMPAIGN_TYPE_APP_OPTION = "app";

export const ADS_CAMPAIGN_TIKTOK_DESTINATION_TYPE_EXTERNAL_WEBSITE =
  "EXTERNAL_WEBSITE";
export const ADS_CAMPAIGN_TIKTOK_DESTINATION_TYPE_INSTANT_PAGE = "INSTANT_PAGE";

export const TIKTOK_PRODUCTS_CONFIGURATION_TYPE = {
  ALL_PRODUCTS: "ALL",
  PRODUCT_SET: "PRODUCT_SET",
  PRODUCT_LIST: "CUSTOMIZED_PRODUCTS",
};
export const ADS_CAMPAIGNS_OBJECTIVES_WITH_CUSTOM_EVENT_TRACKING_META = [
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION,
];
export const ADS_CAMPAIGNS_OBJECTIVES_WITH_CUSTOM_EVENT_TRACKING_TIKTOK = [
  ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION,
];
export const ADS_CAMPAIGNS_PLATFORMS_WITH_TRACKING_ID = [META, TIKTOK];
export const ADS_CAMPAIGN_OBJECTIVES_META_WITH_DESTINATION_TYPE = [
  ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION,
];

export const ADS_CAMPAIGN_OBJECTIVES_WITH_IS_POST_AD = [
  ADS_CAMPAIGN_OBJECTIVE_AWARENESS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
];

export const ADS_CAMPAIGN_APP_PROMOTION_TYPE_RETARGETING_OPTION =
  "APP_RETARGETING";
export const ADS_CAMPAIGN_APP_PROMOTION_TYPE_APP_INSTALL_OPTION = "APP_INSTALL";

export const ADS_CAMPAIGN_META_DESTINATION_TYPE_CATALOG_OPTION = "CATALOG";
export const ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_IN_STORE_OPTION =
  "WEBSITE_AND_IN_STORE";
export const ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_APP_OPTION =
  "WEBSITE_AND_APP";
export const ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE_OPTION =
  "WEBSITE_APP_AND_IN_STORE";
export const ADS_CAMPAIGN_META_DESTINATION_TYPE_NONE_OPTION = "NONE";
export const ADS_CAMPAIGN_META_DESTINATION_TYPE_INSTAGRAM_PROFILE_OPTION =
  "INSTAGRAM_PROFILE";
export const ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_VIDEO_OPTION = "ON_VIDEO";
export const ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION = "ON_POST";
export const ADS_CAMPAIGN_META_DESTINATION_TYPE_WHATSAPP_OPTION = "WHATSAPP";
export const ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_OPTION =
  "INSTAGRAM_DIRECT";
export const ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_MESSAGE_OPTION =
  "MESSENGER";
export const ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_AND_MESSENGER_OPTION =
  "MESSAGING_INSTAGRAM_DIRECT_MESSENGER";
export const ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_FROM_IG_DIRECT_OPTION =
  "LEAD_FROM_IG_DIRECT";
export const ADS_CAMPAIGN_META_DESTINATION_TYPE_GOOGLE_PLAY_OPTION =
  "GOOGLE_PLAY";
export const ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_STORE_OPTION = "APP_STORE";
export const ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_OPTION = "APP";
export const ADS_CAMPAIGN_META_OPTIMIZATION_GOAL_REACH = "REACH";
export const ADS_CAMPAIGN_META_OPTIMIZATION_GOAL_THRUPLAY = "THRUPLAY";
export const ADS_CAMPAIGN_META_OPTIMIZATION_GOAL_LINK_CLICKS = "LINK_CLICKS";
export const ADS_CAMPAIGN_META_OPTIMIZATION_GOAL_LANDING_PAGE_VIEWS =
  "LANDING_PAGE_VIEWS";
export const ADS_CAMPAIGN_META_OPTIMIZATION_GOALS_AWARENESS = [
  ADS_CAMPAIGN_META_OPTIMIZATION_GOAL_REACH,
  ADS_CAMPAIGN_META_OPTIMIZATION_GOAL_THRUPLAY,
];
export const ADS_CAMPAIGN_META_OPTIMIZATION_GOALS_TRAFFIC_WEBSITE = [
  ADS_CAMPAIGN_META_OPTIMIZATION_GOAL_LINK_CLICKS,
  ADS_CAMPAIGN_META_OPTIMIZATION_GOAL_LANDING_PAGE_VIEWS,
];
// Sentinel type for welcome message templates created outside the platform
// (e.g. WhatsApp Forms / Flows). They are shown read-only and forwarded to
// Meta untouched.
export const MESSAGE_TEMPLATE_TYPE_UNSUPPORTED = "unsupported";
export const ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_MESSAGE_TEMPLATE = [
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WHATSAPP_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_MESSAGE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_AND_MESSENGER_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_FROM_IG_DIRECT_OPTION,
];
export const ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_IG_REQUIRED = [
  ADS_CAMPAIGN_META_DESTINATION_TYPE_INSTAGRAM_PROFILE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_MESSAGES_ON_INSTAGRAM_AND_MESSENGER_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_LEAD_FROM_IG_DIRECT_OPTION,
];
export const ADS_CAMPAIGN_META_DESTINATION_TYPES_WEBSITE = [
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_IN_STORE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_APP_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE_OPTION,
];
export const ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_TRACKING_ID = [
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_IN_STORE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_APP_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE_OPTION,
];

export const getIsMetaSalesWhatsappDestination = ({
  objective,
  destinationType,
}) =>
  objective === ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION &&
  destinationType === ADS_CAMPAIGN_META_DESTINATION_TYPE_WHATSAPP_OPTION;

export const ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_OFFLINE_TRACKING_ID = [
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_IN_STORE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE_OPTION,
];
export const ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_APP_ID = [
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_APP_OPTION,
];
export const ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_WEB_FALLBACK_OPTION =
  "deeplink_with_web_fallback";
export const ADS_CAMPAIGN_META_FALLBACK_DEEPLINK_WITH_APPSTORE_FALLBACK_OPTION =
  "deeplink_with_appstore_fallback";
export const ADS_CAMPAIGN_META_FALLBACK_WEB_ONLY_OPTION = "web_only";
export const ADS_CAMPAIGN_META_FALLBACK_CATALOG_OPTION = "catalog";

export const ADS_CAMPAIGN_META_DESTINATION_TYPES_WITH_APP_PROMOTION_OBJECTIVE =
  [
    ADS_CAMPAIGN_META_DESTINATION_TYPE_GOOGLE_PLAY_OPTION,
    ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_STORE_OPTION,
  ];

export const ADS_CAMPAIGN_META_DESTINATION_TYPES_IS_POST_AD_EXCLUDED = [
  ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_VIDEO_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_ON_POST_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_IN_STORE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_AND_APP_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_APP_AND_IN_STORE_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_GOOGLE_PLAY_OPTION,
  ADS_CAMPAIGN_META_DESTINATION_TYPE_APP_STORE_OPTION,
];

export const ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_HOUSING = "HOUSING";
export const ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_EMPLOYMENT = "EMPLOYMENT";
export const ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_FINANCIAL_PRODUCTS_SERVICES =
  "FINANCIAL_PRODUCTS_SERVICES";
export const ADS_CAMPAIGN_META_SPECIAL_AD_CATEGORIES_ISSUES_ELECTIONS_POLITICS =
  "ISSUES_ELECTIONS_POLITICS";

export const ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_HOUSING = "HOUSING";
export const ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_EMPLOYMENT =
  "EMPLOYMENT";
export const ADS_CAMPAIGN_TIKTOK_SPECIAL_AD_CATEGORIES_CREDIT = "CREDIT";

export const ADS_TIKTOK_PLACEMENT_TIKTOK = "PLACEMENT_TIKTOK";
export const ADS_TIKTOK_PLACEMENT_PANGLE = "PLACEMENT_PANGLE";

export const ADS_CAMPAIGN_META_CREATIVE_SOURCE_ADVANTAGE_CATALOG_OPTION =
  "advantageCatalog";
export const ADS_CAMPAIGN_META_CREATIVE_SOURCE_MANUAL_OPTION = "manual";
export const ADS_CAMPAIGN_META_CREATIVE_SOURCE_TYPES = {
  ADVANTAGE_CATALOG: ADS_CAMPAIGN_META_CREATIVE_SOURCE_ADVANTAGE_CATALOG_OPTION,
  MANUAL: ADS_CAMPAIGN_META_CREATIVE_SOURCE_MANUAL_OPTION,
};

/** Meta partnership ads (new creative): primary identity order */
export const ADS_CAMPAIGN_META_PARTNERSHIP_AD_ORDER_SELF_FIRST = "SELF_FIRST";
export const ADS_CAMPAIGN_META_PARTNERSHIP_AD_ORDER_PARTNER_FIRST =
  "PARTNER_FIRST";

export const ADS_CAMPAIGN_APP_PROMOTION_ANDROID_OPTION = "android";
export const ADS_CAMPAIGN_APP_PROMOTION_IOS_OPTION = "ios 14+";
export const ADS_CAMPAIGN_APP_PROMOTION_BOTH_OPTION = "both";

export const ADS_CAMPAIGN_TYPE_BUDGET_DAILY_OPTION = "daily";
export const ADS_CAMPAIGN_TYPE_BUDGET_LIFETIME_OPTION = "total";

export const ADS_CAMPAIGN_TEMPLATE_SINGULAR_OPTION = "singular";
export const ADS_CAMPAIGN_TEMPLATE_MULTIPLE_OPTION = "multiple";
export const ADS_CAMPAIGN_CONTEXT_MIN_LENGTH = 40;
export const ADS_CAMPAIGN_CONTEXT_MAX_LENGTH = 1000;

export const ADS_CAMPAIGN_SEARCH_SEGMENTATION_INTERESTS_TYPE = "interests";
export const ADS_CAMPAIGN_SEARCH_SEGMENTATION_BEHAVIORS_TYPE = "behaviors";
export const ADS_CAMPAIGN_SEARCH_SEGMENTATION_DEMOGRAPHICS_TYPE =
  "demographics";
export const ADS_CAMPAIGN_SEARCH_SEGMENTATION_LOCATIONS_TYPE = "locations";
export const ADS_CAMPAIGN_SEARCH_SEGMENTATION_KEYWORDS_TYPE = "keywords";
export const ADS_CAMPAIGN_MODE_PREVIEW = "preview";
export const ADS_CAMPAIGN_MODE_EDIT = "edit";

export const ADS_CAMPAIGN_CUSTOM_AUDIENCE_TYPE_WEBSITE_OPTION = "website";
export const ADS_CAMPAIGN_CUSTOM_AUDIENCE_TYPE_CUSTOMER_LIST_OPTION =
  "customerList";
export const ADS_CAMPAIGN_CUSTOM_AUDIENCE_TYPE_IG_BUSINESS_OPTION =
  "igBusiness";

export const ADS_CAMPAIGN_SEGMENTATION_MODE_MANUAL = "manual";
export const ADS_CAMPAIGN_SEGMENTATION_MODE_CUSTOM = "custom";

export const ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_MOBILE_FEED_STANDARD =
  "MOBILE_FEED_STANDARD";
export const ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_REELS_MOBILE =
  "FACEBOOK_REELS_MOBILE";
export const ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_STORY = "FACEBOOK_STORY_MOBILE";
export const ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STORY = "INSTAGRAM_STORY";
export const ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_REEL = "INSTAGRAM_REELS";
export const ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_FEED = "INSTAGRAM_FEED_WEB";
export const ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_STANDARD = "INSTAGRAM_STANDARD";
export const ADS_CAMPAIGN_AD_FORMAT_DESKTOP_FEED_STANDARD =
  "DESKTOP_FEED_STANDARD";
export const ADS_CAMPAIGN_AD_FORMAT_INSTREAM_VIDEO_MOBILE =
  "INSTREAM_VIDEO_MOBILE";
export const ADS_CAMPAIGN_AD_FORMAT_MARKETPLACE_MOBILE = "MARKETPLACE_MOBILE";
export const ADS_CAMPAIGN_AD_FORMAT_FACEBOOK_PROFILE_FEED_MOBILE =
  "FACEBOOK_PROFILE_FEED_MOBILE";
export const ADS_CAMPAIGN_AD_FORMAT_WATCH_FEED_MOBILE = "WATCH_FEED_MOBILE";
export const ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_EXPLORE_IMMERSIVE =
  "INSTAGRAM_EXPLORE_IMMERSIVE";
export const ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_EXPLORE_GRID_HOME =
  "INSTAGRAM_EXPLORE_GRID_HOME";
export const ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_PROFILE_FEED =
  "INSTAGRAM_PROFILE_FEED";
export const ADS_CAMPAIGN_AD_FORMAT_INSTAGRAM_SEARCH_GRID =
  "INSTAGRAM_SEARCH_GRID";
export const ADS_CAMPAIGN_AD_FORMAT_MESSENGER_MOBILE_INBOX_MEDIA =
  "MESSENGER_MOBILE_INBOX_MEDIA";
export const ADS_CAMPAIGN_AD_FORMAT_MESSENGER_MOBILE_STORY_MEDIA =
  "MESSENGER_MOBILE_STORY_MEDIA";
export const ADS_CAMPAIGN_AD_FORMAT_RIGHT_COLUMN_STANDARD =
  "RIGHT_COLUMN_STANDARD";
export const ADS_CAMPAIGN_AD_FORMAT_SUGGESTED_VIDEO_DESKTOP =
  "SUGGESTED_VIDEO_DESKTOP";

export const ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_SINGLE_VIDEO = "SINGLE_VIDEO";
export const ADS_CAMPAIGN_AD_FORMAT_TIKTOK_FEED_CAROUSEL_ADS = "CAROUSEL_ADS";
export const ADS_CAMPAIGN_META_AD_FORMATS_FILTERED_BY_SPECIAL_CONFIGURATION = [
  "INSTAGRAM_STORY",
  "INSTAGRAM_REELS",
  "INSTAGRAM_PROFILE_REELS",
];

export const ADS_CAMPAIGN_CREATION_MODE_QUICK = "quick";
export const ADS_CAMPAIGN_CREATION_MODE_ADVANCED = "advanced";

export const ADS_CAMPAIGN_GET_DIRECTIONS_CALL_TO_ACTION_OPTION =
  "GET_DIRECTIONS";

export const ADS_OPTIMIZATION_FULL_CAMPAIGN_TYPE = "fullCampaignOptimization";
export const ADS_OPTIMIZATION_AD_GROUPS_BUDGET_TYPE =
  "adGroupsBudgetOptimization";
export const ADS_OPTIMIZATION_KEYWORDS_TYPE = "keywordsOptimization";

export const ADS_OPTIMIZATION_TYPES = [
  ADS_OPTIMIZATION_FULL_CAMPAIGN_TYPE,
  ADS_OPTIMIZATION_AD_GROUPS_BUDGET_TYPE,
  ADS_OPTIMIZATION_KEYWORDS_TYPE,
];

/** Mínimo en USD por plataforma (se extrapola a otras monedas). LinkedIn: 10 USD; Google/Meta: 1 USD */
export const ADS_CAMPAIGN_PLATFORM_MIN_BUDGET_IN_USD = {
  [GOOGLE]: 1,
  [META]: 1,
  [LINKEDIN]: 10,
};
export const ADS_CAMPAIGN_PLATFORMS_WITH_MIN_BUDGET_IN_USD = Object.keys(
  ADS_CAMPAIGN_PLATFORM_MIN_BUDGET_IN_USD
);

export const ADS_CAMPAIGN_TYPE_GALLERY_ADS_PLATFORMS_POSTS = "posts";
export const ADS_CAMPAIGN_MEDIA_FROM_UPLOAD = "upload";
export const ADS_CAMPAIGN_MEDIA_FROM_CREATIFY = "creatify";
export const ADS_CAMPAIGN_MEDIA_FROM_PHYLLO = "phyllo";
export const ADS_CAMPAIGN_MEDIA_FROM_FACEBOOK_POST = "facebookPost";
export const ADS_CAMPAIGN_MEDIA_FROM_INSTAGRAM_POST = "instagramPost";
export const ADS_CAMPAIGN_MEDIA_FROM_PARTNERSHIP_POST = "partnershipPost";
export const ADS_CAMPAIGN_MEDIA_FROM_TIKTOK_POST = "tiktokPost";
export const ADS_CAMPAIGN_MEDIA_FROM_LINKEDIN_POST = "linkedInPost";
export const ADS_CAMPAIGN_MEDIA_FROM_AD_ACCOUNT = "adAccount";

export const ADS_TIKTOK_CAMPAIGN_OBJECTIVES_VALID_WITH_IMAGES = [
  ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
];

/** TikTok: Pangle placement UI only for traffic, sales, leads, app (not awareness/engagement). */
export const ADS_CAMPAIGN_OBJECTIVES_WITH_PLACEMENT_SELECTOR_TIKTOK = [
  ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_APP_PROMOTION_OPTION,
];

export const ADS_CAMPAIGN_OBJECTIVES_WITH_DESTINATION_TYPE_META = [
  ADS_CAMPAIGN_OBJECTIVE_ENGAGEMENT_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_TRAFFIC_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION,
  ADS_CAMPAIGN_OBJECTIVE_SALES_OPTION,
];

export const ADS_ACTION_TYPE_CREDITS = "credits";
export const ADS_ACTION_TYPE_COINS = "coins";
export const ADS_ACTION_TYPES = {
  GENERATE_CAMPAIGN: "generateCampaign",
  GENERATE_AD_TEXT: "generateAdText",
  GENERATE_TEXT: "generateText",
  CREATIVES: "creatives",
  MESSAGES: "messages",
  VIDEOS: "videos",
  ANIMATE_IMAGE: "animateImage",
  ANALYZE_IMAGE_LAYERS: "analyzeImageLayers",
  GENERATE_CUSTOM_REPORT: "generateCustomReport",
  SCHEDULED_CONTENT: "scheduledContent",
  ADD_CONTENT_GALLERY: "addContentGallery",
};

export const ACTIONS_FREE_BY_TYPE_OF_PLAN = {
  [PLAN_TYPE_PACKAGES]: [
    ADS_ACTION_TYPES.GENERATE_AD_TEXT,
    ADS_ACTION_TYPES.MESSAGES,
    ADS_ACTION_TYPES.GENERATE_CAMPAIGN, // this one is counted/limited in a different way
    ADS_ACTION_TYPES.SCHEDULED_CONTENT,
  ],
  [PLAN_TYPE_CREDITS]: [ADS_ACTION_TYPES.GENERATE_AD_TEXT],
};

export const ADS_CAMPAIGN_ADD_CONTENT_GALLERY_ACTION = {
  type: ADS_ACTION_TYPES.ADD_CONTENT_GALLERY,
};

export const ADS_CAMPAIGNS_DEMO = ["-Op4VxyBCmU2pObz6Zin"];

export const ADS_CAMPAIGNS_DEMO_DATE_RANGE = {
  startDateTime: 1761368400000,
  endDateTime: 1764565200000,
};

export const FROM_MAP_RADIUS_COMPONENT = {
  ONBOARDING: "onboarding",
  AD_ADDRESS: "adAddress",
  AD_GROUP: "adGroup",
};

export const ADS_CAMPAIGN_ENTITIES = {
  ALL_CAMPAIGNS: "allCampaigns",
  PLATFORM: "platform",
  AD_GROUP: "adGroup",
  ASSETS_GROUP: "assetsGroup",
  AD: "ad",
};

export const MAP_MAIN_ACTION_LABELS = {
  cpm: MAIN_STATISTIC_VALUE_CPM_CLARIFICATION,
  click: MAIN_STATISTIC_VALUE_CLICK_CLARIFICATION,
  postEngagement: MAIN_STATISTIC_VALUE_POST_ENGAGEMENT_CLARIFICATION,
  lead: MAIN_STATISTIC_VALUE_LEAD_CLARIFICATION,
  purchase: MAIN_STATISTIC_VALUE_PURCHASE_CLARIFICATION,
  adRecall: MAIN_STATISTIC_VALUE_AD_RECALL_CLARIFICATION,
  videoView: MAIN_STATISTIC_VALUE_VIDEO_VIEW_CLARIFICATION,
  instagramProfile: MAIN_STATISTIC_VALUE_INSTAGRAM_PROFILE_CLARIFICATION,
};

export const ADS_CALL_TO_ACTION_SEND_WHATSAPP_MESSAGE_META_VALUE =
  "WHATSAPP_MESSAGE";

export const ADS_CALL_TO_ACTION_SEND_MESSAGE_PAGE_META_VALUE = "MESSAGE_PAGE";

export const ADS_CALL_TO_ACTION_SEND_MESSAGE_INSTAGRAM_META_VALUE =
  "INSTAGRAM_MESSAGE";

export const AFTER_RENDER_ACTION_PUBLISH = "publish";
export const AFTER_RENDER_ACTION_DOWNLOAD = "download";

export const VIDEO_PENDING_STATUS_CREATIFY = "pending";
export const VIDEO_IN_QUEUE_STATUS_CREATIFY = "in_queue";
export const VIDEO_RUNNING_STATUS_CREATIFY = "running";
export const VIDEO_FAILED_STATUS_CREATIFY = "failed";
export const VIDEO_DONE_STATUS_CREATIFY = "done";
export const VIDEO_REJECTED_STATUS_CREATIFY = "rejected";
export const ALL_VIDEO_FINISHED_STATUS_CREATIFY = [
  VIDEO_FAILED_STATUS_CREATIFY,
  VIDEO_DONE_STATUS_CREATIFY,
  VIDEO_REJECTED_STATUS_CREATIFY,
];
export const ALL_VIDEO_FAILED_STATUS_CREATIFY = [
  VIDEO_FAILED_STATUS_CREATIFY,
  VIDEO_REJECTED_STATUS_CREATIFY,
];

export const RECOMMENDED_ACTION_CATEGORIES = {
  CUSTOM_AUDIENCE: "customAudience",
};

export const ADS_CAMPAIGNS_MAIN_ACTIONS = [
  "cpm",
  "click",
  "postEngagement",
  "lead",
  "purchase",
  "adRecall",
  "videoView",
  "instagramProfile",
];

export const DELAY_DEBOUNCE = 1000;
export const TIME_LOADER_GENERATING_CAMPAIGN_QUICK = 70 * 1000;
export const TIME_LOADER_GENERATING_CAMPAIGN_ADVANCED = 120 * 1000;
export const TIME_LOADER_GENERATING_REPORT_CAMPAIGN = 60 * 1000;
export const TIME_LOADER_OPTIMIZE_CAMPAIGN = 40 * 1000;

//SUPPORTED IMAGE FORMATS
export const LOGO_IMAGE_FORMATS = ["jpeg", "jpg", "png"];
export const GOOGLE_IMAGE_FORMATS = ["jpeg", "png"];
export const GOOGLE_VIDEO_FORMATS = [
  "mp4",
  "mov",
  "avi",
  "mpeg",
  "wmv",
  "m3u8",
];
export const IMAGE_FORMATS = ["jpeg", "jpg", "webp", "png"];
export const EDITOR_ASSETS_LIST_ROOT = "assets";
export const EDITOR_ASSET_FOLDERS_ROOT = "assetFolders";
export const EDITOR_ASSET_FOLDER_CHILDREN_ROOT = "assetFolderChildren";
export const EDITOR_ASSET_FOLDER_CONTENTS_ROOT = "assetFolderContents";
export const CREATIVE_TEMPLATE_FOLDERS_ROOT = "creativeTemplateFolders";
export const CREATIVE_TEMPLATE_FOLDER_CHILDREN_ROOT =
  "creativeTemplateFolderChildren";
export const CREATIVE_TEMPLATE_FOLDER_CONTENTS_ROOT =
  "creativeTemplateFolderContents";
export const ADS_CAMPAIGN_FOLDERS_ROOT = "adsCampaignFolders";
export const ADS_CAMPAIGN_FOLDER_CHILDREN_ROOT = "adsCampaignFolderChildren";
export const ADS_CAMPAIGN_FOLDER_CONTENTS_ROOT = "adsCampaignFolderContents";
export const ADS_CAMPAIGNS_QUERY_PAGE_SIZE = 20;
export const COMPETITOR_FOLDERS_ROOT = "competitorFolders";
export const COMPETITOR_FOLDER_CHILDREN_ROOT = "competitorFolderChildren";
export const COMPETITOR_FOLDER_CONTENTS_ROOT = "competitorFolderContents";
export const COMPETITOR_FAVORITE_DESTINATION_ROOT =
  "competitorFavoriteDestination";
export const COMPETITOR_FOLDER_CONTENT_ID_SEPARATOR = "::";
export const TIKTOK_IMAGE_FORMATS = ["jpeg", "jpg", "png"];
//SUPPORTED VIDEO FORMATS
export const VIDEO_FORMATS = [
  "mp4",
  "quicktime",
  "mov",
  "avi",
  "mpeg",
  "wmv",
  "mov",
  "m3u8",
];

export const FILE_FORMATS = ["pdf"];
export const DOCUMENT_FORMATS_LINKEDIN = ["pdf", "ppt", "pptx", "doc", "docx"];
export const LINKEDIN_AD_FORMAT_DOCUMENT = "SPONSORED_UPDATE_NATIVE_DOCUMENT";
//SUPPORTED AUDIO FORMATS
export const AUDIO_FORMATS = ["mp3"];
export const FORMATS_MEDIA_META = IMAGE_FORMATS.concat(VIDEO_FORMATS);
export const FORMATS_MEDIA_TIKTOK = VIDEO_FORMATS.concat(TIKTOK_IMAGE_FORMATS);
export const FORMATS_MEDIA_GOOGLE = GOOGLE_IMAGE_FORMATS;
export const FORMATS_MEDIA_LINKEDIN = IMAGE_FORMATS;
export const MAX_SIZE_IMAGE = 20971520; // 20MB
export const MAX_SIZE_FILES = 209715200; // 200MB
export const MAX_SIZE_DOCUMENT_LINKEDIN = 104857600; // 100MB
export const MAX_SIZE_IMAGE_VALUE_DISPLAY = 20;

// Constantes para filtros de Gallery
export const ALL_FILTER = "all";
export const CONTENT_FOLDER_ROOT_ID = "__root__";
export const COMPETITOR_FAVORITES_FOLDER_ID = "__favorites__";
export const GALLERY_DRAG_MIME_SELECTED =
  "application/x-buzzly-gallery-selected";

export const FILTERS_MEDIA_CONTENT_TYPE = {
  image: "image",
  video: "video",
  carousel: "carousel",
};

export const MEDIA_DIMENSIONS = {
  horizontal: "horizontal",
  vertical: "vertical",
  square: "square",
  feed: "feed",
  custom: "custom",
};

export const FILTERS_MEDIA_DATE_RANGE = {
  today: "today",
  week: "week",
  month: "month",
  year: "year",
};

// Opciones de filtros
export const contentTypeOptions = [
  { value: ALL_FILTER, label: GALLERY_CONTENT_TYPE },
  { value: FILTERS_MEDIA_CONTENT_TYPE.image, label: FILTERS_GALLERY_IMAGE },
  { value: FILTERS_MEDIA_CONTENT_TYPE.video, label: FILTERS_GALLERY_VIDEO },
  {
    value: FILTERS_MEDIA_CONTENT_TYPE.carousel,
    label: FILTERS_GALLERY_CAROUSEL,
  },
];

export const dimensionsOptions = [
  { value: ALL_FILTER, label: GALLERY_DIMENSIONS },
  {
    value: MEDIA_DIMENSIONS.horizontal,
    label: FILTERS_GALLERY_HORIZONTAL,
  },
  { value: MEDIA_DIMENSIONS.vertical, label: FILTERS_GALLERY_VERTICAL },
  { value: MEDIA_DIMENSIONS.square, label: FILTERS_GALLERY_SQUARE },
  { value: MEDIA_DIMENSIONS.feed, label: FILTERS_GALLERY_FEED },
];

export const dateRangeOptions = [
  { value: ALL_FILTER, label: GALLERY_DATE_RANGE },
  { value: FILTERS_MEDIA_DATE_RANGE.today, label: FILTERS_GALLERY_TODAY },
  { value: FILTERS_MEDIA_DATE_RANGE.week, label: FILTERS_GALLERY_WEEK },
  { value: FILTERS_MEDIA_DATE_RANGE.month, label: FILTERS_GALLERY_MONTH },
  { value: FILTERS_MEDIA_DATE_RANGE.year, label: FILTERS_GALLERY_YEAR },
];

export const DATE_RANGE = {
  today: "today",
  yesterday: "yesterday",
  last_7: "last_7",
  last_14: "last_14",
  last_30: "last_30",
  this_week: "this_week",
  last_week: "last_week",
  this_month: "this_month",
  last_month: "last_month",
  this_year: "this_year",
  last_year: "last_year",
  custom: "custom",
};

export const DATE_RANGE_PRESETS = [
  // Custom manual selection
  { value: DATE_RANGE.custom, label: DATE_RANGE_PRESET_CUSTOM },
  { value: DATE_RANGE.today, label: DATE_RANGE_PRESET_TODAY },
  {
    value: DATE_RANGE.yesterday,
    label: DATE_RANGE_PRESET_YESTERDAY,
  },
  { value: DATE_RANGE.last_7, label: DATE_RANGE_PRESET_LAST_7 },
  { value: DATE_RANGE.last_14, label: DATE_RANGE_PRESET_LAST_14 },
  { value: DATE_RANGE.last_30, label: DATE_RANGE_PRESET_LAST_30 },
  {
    value: DATE_RANGE.this_week,
    label: DATE_RANGE_PRESET_THIS_WEEK,
  },
  {
    value: DATE_RANGE.last_week,
    label: DATE_RANGE_PRESET_LAST_WEEK,
  },
  {
    value: DATE_RANGE.this_month,
    label: DATE_RANGE_PRESET_THIS_MONTH,
  },
  {
    value: DATE_RANGE.last_month,
    label: DATE_RANGE_PRESET_LAST_MONTH,
  },
  {
    value: DATE_RANGE.this_year,
    label: DATE_RANGE_PRESET_THIS_YEAR,
  },
  {
    value: DATE_RANGE.last_year,
    label: DATE_RANGE_PRESET_LAST_YEAR,
  },
];

export const GALLERY_SOURCES = {
  myContent: "myContent",
  adAccount: "adAccount",
  socialPosts: "socialPosts",
  upload: "upload",
  canva: "canva",
};

export const GALLERY_AD_ACCOUNT_PLATFORMS = [GOOGLE, META];

// Bulk individual downloads use ZIP when count exceeds this threshold (2 → ZIP from 3+).
export const GALLERY_BULK_INDIVIDUAL_DOWNLOAD_ZIP_THRESHOLD = 2;

export const MAX_SIZE_FILES_VALUE_DISPLAY = 200;
export const MAX_SIZE_DOCUMENT_LINKEDIN_VALUE_DISPLAY = 100;

export const MIN_DIMENSIONS_CONTENT = {
  width: 600,
  height: 600,
};

export const MAX_CONTENTS_TIKTOK_CAROUSEL = 35;
// CAROUSEL IMAGES LIMITS
export const MAX_CAROUSEL_IMAGES_INSTAGRAM = 5;
export const MAX_CAROUSEL_IMAGES_FACEBOOK = 5;
export const MAX_CAROUSEL_IMAGES_TIKTOK = 5;
export const MIN_CAROUSEL_IMAGES = 2;
export const MAX_CAROUSEL_IMAGES = 10;

export const FILTERS_MEDIA = ["image", "video"];

export const BUTTON_META_ACTION_ID = "button-meta-action";
export const BUTTON_TIKTOK_BUSINESS_ACTION_ID = "button-tiktok-business-action";
export const BUTTON_TIKTOK_ACTION_ID = "button-tiktok-action";
export const BUTTON_GOOGLE_ACTION_ID = "button-google-action";
export const BUTTON_LINKEDIN_ACTION_ID = "button-linkedin-action";

export const BUDGETS_WITH_ONLY_CAMPAIGN_LEVEL = [GOOGLE, LINKEDIN];
export const PLATFORMS_WITH_USE_CAMPAIGN_BUDGET_OPTIONAL = [TIKTOK, META];

export const CAMPAIGNS_WITH_DATES_IN_CAMPAIGN_LEVEL = [GOOGLE, LINKEDIN];

//INTEGRATION SCOPES
export const META_SCOPES = [
  "pages_show_list",
  "ads_management",
  "ads_read",
  "business_management",
  "instagram_basic",
  "instagram_content_publish",
  "pages_read_engagement",
  "pages_manage_ads",
  "whatsapp_business_management",
];
// TikTok Marketing API returns numeric permission IDs in OAuth `scope` (see TikTok docs).
// IDs > Number.MAX_SAFE_INTEGER are valid third-level permissions but round in JS/RTDB — do not
// list them here. BC/advertiser IDs live on `id` / `advertisers`, not in this required set.
export const TIKTOK_BUSINESS_SCOPES = [
  12000000, 19000000, 3, 8, 10, 20, 21, 22, 40, 41, 42, 43, 44, 60, 61, 63, 64,
  68, 69, 90, 91, 92, 94, 150, 151, 152, 153, 700, 6110000,
];
export const CANVA_SCOPES = [
  "asset:read",
  "asset:write",
  "design:content:read",
  "design:content:write",
  "design:meta:read",
  "profile:read",
];
export const GOOGLE_SCOPES = [
  "https://www.googleapis.com/auth/adwords",
  "openid",
];

export const PLATFORMS_SUPPORTED = [META, TIKTOK, GOOGLE, LINKEDIN];

// Owner ad spend ledger. Kept out of DATE_RANGE so RangeDateField presets stay unchanged.
export const AD_SPEND_TRACKING_START_DATE = "2026-10-08";
export const AD_SPEND_DAILY_SERIES_MAX_DAYS = 92;
export const AD_SPEND_TOP_LIMIT = 10;
export const AD_SPEND_DATE_PRESET = {
  historic: "historic",
  last_7: "last_7",
  last_30: "last_30",
  last_90: "last_90",
  this_month: "this_month",
  last_month: "last_month",
  custom: "custom",
};

export const PLATFORMS_SUPPORTED_WITH_COMING_SOON = [
  META,
  TIKTOK,
  GOOGLE,
  LINKEDIN,
];

export const STYLES_BY_PLATFORM = {
  [META]: {
    backgroundColor: MAIN_COLOR_META,
    color: MAIN_COLOR_META_TEXT,
    logo: logoPlatform(META_WHITE),
  },
  [TIKTOK]: {
    backgroundColor: "#fff",
    color: "#000",
    logo: logoPlatform(TIKTOK),
  },
  [GOOGLE]: {
    backgroundColor: "#DB4437",
    color: "#FFF",
    logo: logoPlatform(GOOGLE),
  },
  [LINKEDIN]: {
    backgroundColor: "#0077b5",
    color: "#FFF",
    logo: logoPlatform(LINKEDIN),
  },
};

export const IDS_PLATFORM_BUTTONS = {
  [META]: BUTTON_META_ACTION_ID,
  [TIKTOK]: BUTTON_TIKTOK_BUSINESS_ACTION_ID,
  [GOOGLE]: BUTTON_GOOGLE_ACTION_ID,
  [LINKEDIN]: BUTTON_LINKEDIN_ACTION_ID,
};

export const LABELS_TRACKING_ID = {
  [META]: TRACKING_META_ID_PLACEHOLDER,
  [TIKTOK]: TRACKING_TIKTOK_ID_PLACEHOLDER,
  [GOOGLE]: TRACKING_GOOGLE_ID_PLACEHOLDER,
  [LINKEDIN]: TRACKING_LINKEDIN_ID_PLACEHOLDER,
};
export const AD_ACCOUNT_PLATFORMS_LABELS = {
  [META]: AD_ACCOUNT_META_PLACEHOLDER,
  [TIKTOK]: AD_ACCOUNT_TIKTOK_PLACEHOLDER,
  [GOOGLE]: AD_ACCOUNT_GOOGLE_PLACEHOLDER,
  [LINKEDIN]: AD_ACCOUNT_LINKEDIN_PLACEHOLDER,
};
export const LABELS_TRACKING_CUSTOM_EVENTS = {
  [META]: TRACKING_CUSTOM_EVENT_ID_META_PLACEHOLDER,
  [TIKTOK]: TRACKING_CUSTOM_EVENT_ID_TIKTOK_PLACEHOLDER,
  [GOOGLE]: TRACKING_CUSTOM_EVENT_ID_META_PLACEHOLDER,
  [LINKEDIN]: TRACKING_CUSTOM_EVENT_ID_LINKEDIN_PLACEHOLDER,
};

export const CHAT_CONFIGURATION_ADS_DETAILED_REPORT_ID = "adsDetailedReport";
export const CHAT_CONFIGURATION_ADS_DETAILED_REPORT_SUMMARY_ID =
  "adsDetailedReportSummary";

export const metaCurrenciesWithDecimals = [
  "DZD",
  "ARS",
  "AUD",
  "BHD",
  "BDT",
  "BOB",
  "BGN",
  "BRL",
  "GBP",
  "CAD",
  "CNY",
  "HRK",
  "CZK",
  "DKK",
  "EGP",
  "EUR",
  "GTQ",
  "HNL",
  "HKD",
  "INR",
  "ILS",
  "JOD",
  "KES",
  "LVL",
  "LTL",
  "MOP",
  "MYR",
  "MXN",
  "NZD",
  "NIO",
  "NGN",
  "NOK",
  "PKR",
  "PEN",
  "PHP",
  "PLN",
  "QAR",
  "RON",
  "RUB",
  "SAR",
  "RSD",
  "SGD",
  "SKK",
  "ZAR",
  "SEK",
  "CHF",
  "THB",
  "TRY",
  "AED",
  "UAH",
  "USD",
  "UYU",
  "VEF",
  "FBZ",
  "VES",
];
export const googleCurrenciesWithDecimals = [
  "AED",
  "ARS",
  "AUD",
  "BGN",
  "BND",
  "BOB",
  "BRL",
  "CAD",
  "CHF",
  "CNY",
  "CSD",
  "CZK",
  "DEM",
  "DKK",
  "EEK",
  "EGP",
  "EUR",
  "FJD",
  "FRF",
  "GBP",
  "HKD",
  "HRK",
  "HUF",
  "ILS",
  "INR",
  "JOD",
  "KES",
  "LKR",
  "LTL",
  "MAD",
  "MTL",
  "MXN",
  "MYR",
  "NGN",
  "NOK",
  "NZD",
  "PEN",
  "PHP",
  "PLN",
  "RON",
  "RUB",
  "SAR",
  "SEK",
  "SGD",
  "SIT",
  "SKK",
  "THB",
  "TND",
  "TRY",
  "TWD",
  "UAH",
  "USD",
  "UYU",
  "VEB",
  "VEF",
  "ZAR",
];

export const linkedinCurrenciesWithDecimals = [
  "AFN",
  "EUR",
  "ALL",
  "DZD",
  "USD",
  "AOA",
  "XCD",
  "ARS",
  "AMD",
  "AWG",
  "AUD",
  "AZN",
  "BSD",
  "BDT",
  "BBD",
  "BYN",
  "BZD",
  "BMD",
  "BTN",
  "BOB",
  "BOV",
  "BAM",
  "BWP",
  "NOK",
  "BRL",
  "BND",
  "BGN",
  "CVE",
  "KHR",
  "CAD",
  "KYD",
  "CNY",
  "COP",
  "COU",
  "CDF",
  "NZD",
  "CRC",
  "CUP",
  "CUC",
  "ANG",
  "CZK",
  "DKK",
  "XCD",
  "DOP",
  "EGP",
  "SVC",
  "ERN",
  "SZL",
  "ETB",
  "FKP",
  "FJD",
  "GMD",
  "GEL",
  "GHS",
  "GIP",
  "GTQ",
  "GBP",
  "GYD",
  "HTG",
  "HNL",
  "HKD",
  "HUF",
  "INR",
  "IDR",
  "IRR",
  "IQD",
  "ILS",
  "JMD",
  "JOD",
  "KZT",
  "KES",
  "KPW",
  "KWD",
  "KGS",
  "LAK",
  "LBP",
  "LSL",
  "ZAR",
  "LRD",
  "LYD",
  "CHF",
  "MOP",
  "MKD",
  "MGA",
  "MWK",
  "MYR",
  "MVR",
  "MXN",
  "MXV",
  "MDL",
  "MNT",
  "MAD",
  "MZN",
  "MMK",
  "NAD",
  "NPR",
  "NIO",
  "NGN",
  "OMR",
  "PKR",
  "PAB",
  "PGK",
  "PEN",
  "PHP",
  "PLN",
  "QAR",
  "RON",
  "RUB",
  "SHP",
  "SCR",
  "SLE",
  "SGD",
  "SOS",
  "SSP",
  "LKR",
  "SDG",
  "SRD",
  "SEK",
  "CHE",
  "CHW",
  "SYP",
  "TWD",
  "TJS",
  "TZS",
  "THB",
  "TTD",
  "TND",
  "TRY",
  "TMT",
  "UAH",
  "AED",
  "USN",
  "UYU",
  "UZS",
  "VES",
  "VED",
  "ZWG",
  "ZMW",
  "BHD",
  "IQD",
  "JOD",
  "KWD",
  "LYD",
  "OMR",
  "TND",
  "CLF",
  "UYW",
];

export const MIN_DAILY_BUDGET_TIKTOK = 20;
export const tiktokCurrenciesData = {
  USD: {
    currency: "US Dollar",
    baseMultiplier: 1,
    precision: 0.01,
    minDailyBudget: 20,
    minDailyBudgetCampaign: 50,
  },
  EUR: {
    currency: "Euro",
    baseMultiplier: 1,
    precision: 0.01,
    minDailyBudget: 20,
    minDailyBudgetCampaign: 50,
  },
  JPY: {
    currency: "Japanese Yen",
    baseMultiplier: 100,
    precision: 1,
    minDailyBudget: 2000,
    minDailyBudgetCampaign: 5000,
  },
  HKD: {
    currency: "Hong Kong Dollar",
    baseMultiplier: 10,
    precision: 0.01,
    minDailyBudget: 200,
    minDailyBudgetCampaign: 500,
  },
  GBP: {
    currency: "British Pound",
    baseMultiplier: 1,
    precision: 0.01,
    minDailyBudget: 20,
    minDailyBudgetCampaign: 50,
  },
  MYR: {
    currency: "Malaysian Ringgit",
    baseMultiplier: 1,
    precision: 0.01,
    minDailyBudget: 20,
    minDailyBudgetCampaign: 50,
  },
  RUB: {
    currency: "Russian Ruble",
    baseMultiplier: 100,
    precision: 0.01,
    minDailyBudget: 2000,
    minDailyBudgetCampaign: 5000,
  },
  ZAR: {
    currency: "South African Rand",
    baseMultiplier: 10,
    precision: 0.01,
    minDailyBudget: 200,
    minDailyBudgetCampaign: 500,
  },
  KRW: {
    currency: "South Korean Won",
    baseMultiplier: 1000,
    precision: 1,
    minDailyBudget: 20000,
    minDailyBudgetCampaign: 50000,
  },
  AED: {
    currency: "UAE Dirham",
    baseMultiplier: 1,
    precision: 0.01,
    minDailyBudget: 20,
    minDailyBudgetCampaign: 50,
  },
  SAR: {
    currency: "Saudi Riyal",
    baseMultiplier: 1,
    precision: 0.01,
    minDailyBudget: 20,
    minDailyBudgetCampaign: 50,
  },
  HUF: {
    currency: "Hungarian Forint",
    baseMultiplier: 1,
    precision: 1,
    minDailyBudget: 20,
    minDailyBudgetCampaign: 50,
  },
  PLN: {
    currency: "Polish Zloty",
    baseMultiplier: 4,
    precision: 0.01,
    minDailyBudget: 80,
    minDailyBudgetCampaign: 200,
  },
  DKK: {
    currency: "Danish Krone",
    baseMultiplier: 10,
    precision: 0.01,
    minDailyBudget: 200,
    minDailyBudgetCampaign: 500,
  },
  SEK: {
    currency: "Swedish Krona",
    baseMultiplier: 10,
    precision: 0.01,
    minDailyBudget: 200,
    minDailyBudgetCampaign: 500,
  },
  NOK: {
    currency: "Norwegian Krone",
    baseMultiplier: 10,
    precision: 0.01,
    minDailyBudget: 200,
    minDailyBudgetCampaign: 500,
  },
  TRY: {
    currency: "Turkish Lira",
    baseMultiplier: 10,
    precision: 0.01,
    minDailyBudget: 200,
    minDailyBudgetCampaign: 500,
  },
  MXN: {
    currency: "Mexican Peso",
    baseMultiplier: 10,
    precision: 0.01,
    minDailyBudget: 200,
    minDailyBudgetCampaign: 500,
  },
  THB: {
    currency: "Thai Baht",
    baseMultiplier: 10,
    precision: 0.01,
    minDailyBudget: 200,
    minDailyBudgetCampaign: 500,
  },
  AUD: {
    currency: "Australian Dollar",
    baseMultiplier: 1,
    precision: 0.01,
    minDailyBudget: 20,
    minDailyBudgetCampaign: 50,
  },
  CAD: {
    currency: "Canadian Dollar",
    baseMultiplier: 1,
    precision: 0.01,
    minDailyBudget: 20,
    minDailyBudgetCampaign: 50,
  },
  NZD: {
    currency: "New Zealand Dollar",
    baseMultiplier: 1,
    precision: 0.01,
    minDailyBudget: 20,
    minDailyBudgetCampaign: 50,
  },
  SGD: {
    currency: "Singapore Dollar",
    baseMultiplier: 1,
    precision: 0.01,
    minDailyBudget: 20,
    minDailyBudgetCampaign: 50,
  },
  CHF: {
    currency: "Swiss Franc",
    baseMultiplier: 1,
    precision: 0.01,
    minDailyBudget: 20,
    minDailyBudgetCampaign: 50,
  },
  CNY: {
    currency: "Chinese Yuan",
    baseMultiplier: 10,
    precision: 0.01,
    minDailyBudget: 200,
    minDailyBudgetCampaign: 500,
  },
  DZD: {
    currency: "Algerian Dinar",
    baseMultiplier: 100,
    precision: 0.01,
    minDailyBudget: 2000,
    minDailyBudgetCampaign: 5000,
  },
  ARS: {
    currency: "Argentine Peso",
    baseMultiplier: 1,
    precision: 0.01,
    minDailyBudget: 20,
    minDailyBudgetCampaign: 50,
  },
  BDT: {
    currency: "Bangladeshi Taka",
    baseMultiplier: 100,
    precision: 0.01,
    minDailyBudget: 2000,
    minDailyBudgetCampaign: 5000,
  },
  BOB: {
    currency: "Bolivian Boliviano",
    baseMultiplier: 10,
    precision: 0.01,
    minDailyBudget: 200,
    minDailyBudgetCampaign: 500,
  },
  BRL: {
    currency: "Brazilian Real",
    baseMultiplier: 1,
    precision: 0.01,
    minDailyBudget: 20,
    minDailyBudgetCampaign: 50,
  },
  CLP: {
    currency: "Chilean Peso",
    baseMultiplier: 1000,
    precision: 1,
    minDailyBudget: 20000,
    minDailyBudgetCampaign: 50000,
  },
  COP: {
    currency: "Colombian Peso",
    baseMultiplier: 1000,
    precision: 0.01,
    minDailyBudget: 20000,
    minDailyBudgetCampaign: 50000,
  },
  CRC: {
    currency: "Costa Rican Colon",
    baseMultiplier: 1000,
    precision: 0.01,
    minDailyBudget: 20000,
    minDailyBudgetCampaign: 50000,
  },
  CZK: {
    currency: "Czech Koruna",
    baseMultiplier: 10,
    precision: 0.01,
    minDailyBudget: 200,
    minDailyBudgetCampaign: 500,
  },
  EGP: {
    currency: "Egyptian Pound",
    baseMultiplier: 10,
    precision: 0.01,
    minDailyBudget: 200,
    minDailyBudgetCampaign: 500,
  },
  GTQ: {
    currency: "Guatemalan Quetzal",
    baseMultiplier: 10,
    precision: 0.01,
    minDailyBudget: 200,
    minDailyBudgetCampaign: 500,
  },
  HNL: {
    currency: "Honduran Lempira",
    baseMultiplier: 10,
    precision: 0.01,
    minDailyBudget: 200,
    minDailyBudgetCampaign: 500,
  },
  ISK: {
    currency: "Icelandic Krona",
    baseMultiplier: 100,
    precision: 1,
    minDailyBudget: 2000,
    minDailyBudgetCampaign: 5000,
  },
  INR: {
    currency: "Indian Rupee",
    baseMultiplier: 100,
    precision: 0.01,
    minDailyBudget: 2000,
    minDailyBudgetCampaign: 5000,
  },
  IDR: {
    currency: "Indonesian Rupiah",
    baseMultiplier: 10000,
    precision: 1,
    minDailyBudget: 200000,
    minDailyBudgetCampaign: 500000,
  },
  ILS: {
    currency: "Israeli New Shekel",
    baseMultiplier: 1,
    precision: 0.01,
    minDailyBudget: 20,
    minDailyBudgetCampaign: 50,
  },
  KES: {
    currency: "Kenyan Shilling",
    baseMultiplier: 100,
    precision: 0.01,
    minDailyBudget: 2000,
    minDailyBudgetCampaign: 5000,
  },
  MOP: {
    currency: "Macanese Pataca",
    baseMultiplier: 10,
    precision: 0.01,
    minDailyBudget: 200,
    minDailyBudgetCampaign: 500,
  },
  TWD: {
    currency: "New Taiwan Dollar",
    baseMultiplier: 10,
    precision: 1,
    minDailyBudget: 200,
    minDailyBudgetCampaign: 500,
  },
  NIO: {
    currency: "Nicaraguan Cordoba",
    baseMultiplier: 10,
    precision: 0.01,
    minDailyBudget: 200,
    minDailyBudgetCampaign: 500,
  },
  NGN: {
    currency: "Nigerian Naira",
    baseMultiplier: 100,
    precision: 0.01,
    minDailyBudget: 2000,
    minDailyBudgetCampaign: 5000,
  },
  PKR: {
    currency: "Pakistani Rupee",
    baseMultiplier: 100,
    precision: 0.01,
    minDailyBudget: 2000,
    minDailyBudgetCampaign: 5000,
  },
  PYG: {
    currency: "Paraguayan Guarani",
    baseMultiplier: 10000,
    precision: 1,
    minDailyBudget: 200000,
    minDailyBudgetCampaign: 500000,
  },
  PEN: {
    currency: "Peruvian Nuevo Sol",
    baseMultiplier: 1,
    precision: 0.01,
    minDailyBudget: 20,
    minDailyBudgetCampaign: 50,
  },
  PHP: {
    currency: "Philippine Peso",
    baseMultiplier: 50,
    precision: 0.01,
    minDailyBudget: 1000,
    minDailyBudgetCampaign: 2500,
  },
  QAR: {
    currency: "Qatari Riyal",
    baseMultiplier: 1,
    precision: 0.01,
    minDailyBudget: 20,
    minDailyBudgetCampaign: 50,
  },
  RON: {
    currency: "Romanian Leu",
    baseMultiplier: 1,
    precision: 0.01,
    minDailyBudget: 20,
    minDailyBudgetCampaign: 50,
  },
  UAH: {
    currency: "Ukrainian Hryvnia",
    baseMultiplier: 10,
    precision: 0.01,
    minDailyBudget: 200,
    minDailyBudgetCampaign: 500,
  },
  UYU: {
    currency: "Uruguayan Peso",
    baseMultiplier: 10,
    precision: 0.01,
    minDailyBudget: 200,
    minDailyBudgetCampaign: 500,
  },
  VEF: {
    currency: "Venezuelan Bolivar",
    baseMultiplier: 100000,
    precision: 0.01,
    minDailyBudget: 2000000,
    minDailyBudgetCampaign: 5000000,
  },
  VND: {
    currency: "Vietnamese Dong",
    baseMultiplier: 10000,
    precision: 1,
    minDailyBudget: 200000,
    minDailyBudgetCampaign: 500000,
  },
};

export const COUNTRIES = [
  { value: "AD", label: COUNTRY_ANDORRA, phone: "376" },
  { value: "AE", label: COUNTRY_UNITED_ARAB_EMIRATES, phone: "971" },
  { value: "AF", label: COUNTRY_AFGHANISTAN, phone: "93" },
  { value: "AG", label: COUNTRY_ANTIGUA_AND_BARBUDA, phone: "1-268" },
  { value: "AI", label: COUNTRY_ANGUILLA, phone: "1-264" },
  { value: "AL", label: COUNTRY_ALBANIA, phone: "355" },
  { value: "AM", label: COUNTRY_ARMENIA, phone: "374" },
  { value: "AO", label: COUNTRY_ANGOLA, phone: "244" },
  { value: "AQ", label: COUNTRY_ANTARCTICA, phone: "672" },
  { value: "AR", label: COUNTRY_ARGENTINA, phone: "54" },
  { value: "AS", label: COUNTRY_AMERICAN_SAMOA, phone: "1-684" },
  { value: "AT", label: COUNTRY_AUSTRIA, phone: "43" },
  { value: "AU", label: COUNTRY_AUSTRALIA, phone: "61" },
  { value: "AW", label: COUNTRY_ARUBA, phone: "297" },
  { value: "AX", label: COUNTRY_ALLAND_ISLANDS, phone: "358" },
  { value: "AZ", label: COUNTRY_AZERBAIJAN, phone: "994" },
  { value: "BA", label: COUNTRY_BOSNIA_AND_HERZEGOVINA, phone: "387" },
  { value: "BB", label: COUNTRY_BARBADOS, phone: "1-246" },
  { value: "BD", label: COUNTRY_BANGLADESH, phone: "880" },
  { value: "BE", label: COUNTRY_BELGIUM, phone: "32" },
  { value: "BF", label: COUNTRY_BURKINA_FASO, phone: "226" },
  { value: "BG", label: COUNTRY_BULGARIA, phone: "359" },
  { value: "BH", label: COUNTRY_BAHRAIN, phone: "973" },
  { value: "BI", label: COUNTRY_BURUNDI, phone: "257" },
  { value: "BJ", label: COUNTRY_BENIN, phone: "229" },
  { value: "BL", label: COUNTRY_SAINT_BARTHELEMY, phone: "590" },
  { value: "BM", label: COUNTRY_BERMUDA, phone: "1-441" },
  { value: "BN", label: COUNTRY_BRUNEI_DARUSSALAM, phone: "673" },
  { value: "BO", label: COUNTRY_BOLIVIA, phone: "591" },
  { value: "BR", label: COUNTRY_BRAZIL, phone: "55" },
  { value: "BS", label: COUNTRY_BAHAMAS, phone: "1-242" },
  { value: "BT", label: COUNTRY_BHUTAN, phone: "975" },
  { value: "BV", label: COUNTRY_BOUVET_ISLAND, phone: "47" },
  { value: "BW", label: COUNTRY_BOTSWANA, phone: "267" },
  { value: "BY", label: COUNTRY_BELARUS, phone: "375" },
  { value: "BZ", label: COUNTRY_BELIZE, phone: "501" },
  { value: "CA", label: COUNTRY_CANADA, phone: "1" },
  { value: "CC", label: COUNTRY_COCOS_KEELING_ISLANDS, phone: "61" },
  {
    value: "CD",
    label: COUNTRY_CONGO_DEMOCRATIC_REPUBLIC_OF_THE,
    phone: "243",
  },
  { value: "CF", label: COUNTRY_CENTRAL_AFRICAN_REPUBLIC, phone: "236" },
  { value: "CG", label: COUNTRY_CONGO_REPUBLIC_OF_THE, phone: "242" },
  { value: "CH", label: COUNTRY_SWITZERLAND, phone: "41" },
  { value: "CI", label: COUNTRY_COTE_D_IVOIRE, phone: "225" },
  { value: "CK", label: COUNTRY_COOK_ISLANDS, phone: "682" },
  { value: "CL", label: COUNTRY_CHILE, phone: "56" },
  { value: "CM", label: COUNTRY_CAMEROON, phone: "237" },
  { value: "CN", label: COUNTRY_CHINA, phone: "86" },
  { value: "CO", label: COUNTRY_COLOMBIA, phone: "57" },
  { value: "CR", label: COUNTRY_COSTA_RICA, phone: "506" },
  { value: "CU", label: COUNTRY_CUBA, phone: "53" },
  { value: "CV", label: COUNTRY_CAPE_VERDE, phone: "238" },
  { value: "CW", label: COUNTRY_CURACAO, phone: "599" },
  { value: "CX", label: COUNTRY_CHRISTMAS_ISLAND, phone: "61" },
  { value: "CY", label: COUNTRY_CYPRUS, phone: "357" },
  { value: "CZ", label: COUNTRY_CZECH_REPUBLIC, phone: "420" },
  { value: "DE", label: COUNTRY_GERMANY, phone: "49" },
  { value: "DJ", label: COUNTRY_DJIBOUTI, phone: "253" },
  { value: "DK", label: COUNTRY_DENMARK, phone: "45" },
  { value: "DM", label: COUNTRY_DOMINICA, phone: "1-767" },
  { value: "DO", label: COUNTRY_DOMINICAN_REPUBLIC, phone: "1-809" },
  { value: "DZ", label: COUNTRY_ALGERIA, phone: "213" },
  { value: "EC", label: COUNTRY_ECUADOR, phone: "593" },
  { value: "EE", label: COUNTRY_ESTONIA, phone: "372" },
  { value: "EG", label: COUNTRY_EGYPT, phone: "20" },
  { value: "EH", label: COUNTRY_WESTERN_SAHARA, phone: "212" },
  { value: "ER", label: COUNTRY_ERITREA, phone: "291" },
  { value: "ES", label: COUNTRY_SPAIN, phone: "34" },
  { value: "ET", label: COUNTRY_ETHIOPIA, phone: "251" },
  { value: "FI", label: COUNTRY_FINLAND, phone: "358" },
  { value: "FJ", label: COUNTRY_FIJI, phone: "679" },
  { value: "FK", label: COUNTRY_FALKLAND_ISLANDS_MALVINAS, phone: "500" },
  { value: "FM", label: COUNTRY_MICRONESIA_FEDERATED_STATES_OF, phone: "691" },
  { value: "FO", label: COUNTRY_FAROE_ISLANDS, phone: "298" },
  { value: "FR", label: COUNTRY_FRANCE, phone: "33" },
  { value: "GA", label: COUNTRY_GABON, phone: "241" },
  { value: "GB", label: COUNTRY_UNITED_KINGDOM, phone: "44" },
  { value: "GD", label: COUNTRY_GRENADA, phone: "1-473" },
  { value: "GE", label: COUNTRY_GEORGIA, phone: "995" },
  { value: "GF", label: COUNTRY_FRENCH_GUIANA, phone: "594" },
  { value: "GG", label: COUNTRY_GUERNSEY, phone: "44" },
  { value: "GH", label: COUNTRY_GHANA, phone: "233" },
  { value: "GI", label: COUNTRY_GIBRALTAR, phone: "350" },
  { value: "GL", label: COUNTRY_GREENLAND, phone: "299" },
  { value: "GM", label: COUNTRY_GAMBIA, phone: "220" },
  { value: "GN", label: COUNTRY_GUINEA, phone: "224" },
  { value: "GP", label: COUNTRY_GUADELOUPE, phone: "590" },
  { value: "GQ", label: COUNTRY_EQUATORIAL_GUINEA, phone: "240" },
  { value: "GR", label: COUNTRY_GREECE, phone: "30" },
  {
    value: "GS",
    label: COUNTRY_SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS,
    phone: "500",
  },
  { value: "GT", label: COUNTRY_GUATEMALA, phone: "502" },
  { value: "GU", label: COUNTRY_GUAM, phone: "1-671" },
  { value: "GW", label: COUNTRY_GUINEA_BISSAU, phone: "245" },
  { value: "GY", label: COUNTRY_GUYANA, phone: "592" },
  { value: "HK", label: COUNTRY_HONG_KONG, phone: "852" },
  {
    value: "HM",
    label: COUNTRY_HEARD_ISLAND_AND_MCDONALD_ISLANDS,
    phone: "672",
  },
  { value: "HN", label: COUNTRY_HONDURAS, phone: "504" },
  { value: "HR", label: COUNTRY_CROATIA, phone: "385" },
  { value: "HT", label: COUNTRY_HAITI, phone: "509" },
  { value: "HU", label: COUNTRY_HUNGARY, phone: "36" },
  { value: "ID", label: COUNTRY_INDONESIA, phone: "62" },
  { value: "IE", label: COUNTRY_IRELAND, phone: "353" },
  { value: "IL", label: COUNTRY_ISRAEL, phone: "972" },
  { value: "IM", label: COUNTRY_ISLE_OF_MAN, phone: "44" },
  { value: "IN", label: COUNTRY_INDIA, phone: "91" },
  { value: "IO", label: COUNTRY_BRITISH_INDIAN_OCEAN_TERRITORY, phone: "246" },
  { value: "IQ", label: COUNTRY_IRAQ, phone: "964" },
  { value: "IR", label: COUNTRY_IRAN_ISLAMIC_REPUBLIC_OF, phone: "98" },
  { value: "IS", label: COUNTRY_ICELAND, phone: "354" },
  { value: "IT", label: COUNTRY_ITALY, phone: "39" },
  { value: "JE", label: COUNTRY_JERSEY, phone: "44" },
  { value: "JM", label: COUNTRY_JAMAICA, phone: "1-876" },
  { value: "JO", label: COUNTRY_JORDAN, phone: "962" },
  { value: "JP", label: COUNTRY_JAPAN, phone: "81" },
  { value: "KE", label: COUNTRY_KENYA, phone: "254" },
  { value: "KG", label: COUNTRY_KYRGYZSTAN, phone: "996" },
  { value: "KH", label: COUNTRY_CAMBODIA, phone: "855" },
  { value: "KI", label: COUNTRY_KIRIBATI, phone: "686" },
  { value: "KM", label: COUNTRY_COMOROS, phone: "269" },
  { value: "KN", label: COUNTRY_SAINT_KITTS_AND_NEVIS, phone: "1-869" },
  {
    value: "KP",
    label: COUNTRY_KOREA_DEMOCRATIC_PEOPLES_REPUBLIC_OF,
    phone: "850",
  },
  { value: "KR", label: COUNTRY_KOREA_REPUBLIC_OF, phone: "82" },
  { value: "KW", label: COUNTRY_KUWAIT, phone: "965" },
  { value: "KY", label: COUNTRY_CAYMAN_ISLANDS, phone: "1-345" },
  { value: "KZ", label: COUNTRY_KAZAKHSTAN, phone: "7" },
  { value: "LA", label: COUNTRY_LAO_PEOPLES_DEMOCRATIC_REPUBLIC, phone: "856" },
  { value: "LB", label: COUNTRY_LEBANON, phone: "961" },
  { value: "LC", label: COUNTRY_SAINT_LUCIA, phone: "1-758" },
  { value: "LI", label: COUNTRY_LIECHTENSTEIN, phone: "423" },
  { value: "LK", label: COUNTRY_SRI_LANKA, phone: "94" },
  { value: "LR", label: COUNTRY_LIBERIA, phone: "231" },
  { value: "LS", label: COUNTRY_LESOTHO, phone: "266" },
  { value: "LT", label: COUNTRY_LITHUANIA, phone: "370" },
  { value: "LU", label: COUNTRY_LUXEMBOURG, phone: "352" },
  { value: "LV", label: COUNTRY_LATVIA, phone: "371" },
  { value: "LY", label: COUNTRY_LIBYA, phone: "218" },
  { value: "MA", label: COUNTRY_MOROCCO, phone: "212" },
  { value: "MC", label: COUNTRY_MONACO, phone: "377" },
  { value: "MD", label: COUNTRY_MOLDOVA_REPUBLIC_OF, phone: "373" },
  { value: "ME", label: COUNTRY_MONTENEGRO, phone: "382" },
  { value: "MF", label: COUNTRY_SAINT_MARTIN_FRENCH_PART, phone: "590" },
  { value: "MG", label: COUNTRY_MADAGASCAR, phone: "261" },
  { value: "MH", label: COUNTRY_MARSHALL_ISLANDS, phone: "692" },
  {
    value: "MK",
    label: COUNTRY_MACEDONIA_THE_FORMER_YUGOSLAV_REPUBLIC_OF,
    phone: "389",
  },
  { value: "ML", label: COUNTRY_MALI, phone: "223" },
  { value: "MM", label: COUNTRY_MYANMAR, phone: "95" },
  { value: "MN", label: COUNTRY_MONGOLIA, phone: "976" },
  { value: "MO", label: COUNTRY_MACAO, phone: "853" },
  { value: "MP", label: COUNTRY_NORTHERN_MARIANA_ISLANDS, phone: "1-670" },
  { value: "MQ", label: COUNTRY_MARTINIQUE, phone: "596" },
  { value: "MR", label: COUNTRY_MAURITANIA, phone: "222" },
  { value: "MS", label: COUNTRY_MONTSERRAT, phone: "1-664" },
  { value: "MT", label: COUNTRY_MALTA, phone: "356" },
  { value: "MU", label: COUNTRY_MAURITIUS, phone: "230" },
  { value: "MV", label: COUNTRY_MALDIVES, phone: "960" },
  { value: "MW", label: COUNTRY_MALAWI, phone: "265" },
  { value: "MX", label: COUNTRY_MEXICO, phone: "52" },
  { value: "MY", label: COUNTRY_MALAYSIA, phone: "60" },
  { value: "MZ", label: COUNTRY_MOZAMBIQUE, phone: "258" },
  { value: "NA", label: COUNTRY_NAMIBIA, phone: "264" },
  { value: "NC", label: COUNTRY_NEW_CALEDONIA, phone: "687" },
  { value: "NE", label: COUNTRY_NIGER, phone: "227" },
  { value: "NF", label: COUNTRY_NORFOLK_ISLAND, phone: "672" },
  { value: "NG", label: COUNTRY_NIGERIA, phone: "234" },
  { value: "NI", label: COUNTRY_NICARAGUA, phone: "505" },
  { value: "NL", label: COUNTRY_NETHERLANDS, phone: "31" },
  { value: "NO", label: COUNTRY_NORWAY, phone: "47" },
  { value: "NP", label: COUNTRY_NEPAL, phone: "977" },
  { value: "NR", label: COUNTRY_NAURU, phone: "674" },
  { value: "NU", label: COUNTRY_NIUE, phone: "683" },
  { value: "NZ", label: COUNTRY_NEW_ZEALAND, phone: "64" },
  { value: "OM", label: COUNTRY_OMAN, phone: "968" },
  { value: "PA", label: COUNTRY_PANAMA, phone: "507" },
  { value: "PE", label: COUNTRY_PERU, phone: "51" },
  { value: "PF", label: COUNTRY_FRENCH_POLYNESIA, phone: "689" },
  { value: "PG", label: COUNTRY_PAPUA_NEW_GUINEA, phone: "675" },
  { value: "PH", label: COUNTRY_PHILIPPINES, phone: "63" },
  { value: "PK", label: COUNTRY_PAKISTAN, phone: "92" },
  { value: "PL", label: COUNTRY_POLAND, phone: "48" },
  { value: "PM", label: COUNTRY_SAINT_PIERRE_AND_MIQUELON, phone: "508" },
  { value: "PN", label: COUNTRY_PITCAIRN, phone: "870" },
  { value: "PR", label: COUNTRY_PUERTO_RICO, phone: "1" },
  { value: "PS", label: COUNTRY_PALESTINE_STATE_OF, phone: "970" },
  { value: "PT", label: COUNTRY_PORTUGAL, phone: "351" },
  { value: "PW", label: COUNTRY_PALAU, phone: "680" },
  { value: "PY", label: COUNTRY_PARAGUAY, phone: "595" },
  { value: "QA", label: COUNTRY_QATAR, phone: "974" },
  { value: "RE", label: COUNTRY_REUNION, phone: "262" },
  { value: "RO", label: COUNTRY_ROMANIA, phone: "40" },
  { value: "RS", label: COUNTRY_SERBIA, phone: "381" },
  { value: "RU", label: COUNTRY_RUSSIAN_FEDERATION, phone: "7" },
  { value: "RW", label: COUNTRY_RWANDA, phone: "250" },
  { value: "SA", label: COUNTRY_SAUDI_ARABIA, phone: "966" },
  { value: "SB", label: COUNTRY_SOLOMON_ISLANDS, phone: "677" },
  { value: "SC", label: COUNTRY_SEYCHELLES, phone: "248" },
  { value: "SD", label: COUNTRY_SUDAN, phone: "249" },
  { value: "SE", label: COUNTRY_SWEDEN, phone: "46" },
  { value: "SG", label: COUNTRY_SINGAPORE, phone: "65" },
  { value: "SH", label: COUNTRY_SAINT_HELENA, phone: "290" },
  { value: "SI", label: COUNTRY_SLOVENIA, phone: "386" },
  { value: "SJ", label: COUNTRY_SVALBARD_AND_JAN_MAYEN, phone: "47" },
  { value: "SK", label: COUNTRY_SLOVAKIA, phone: "421" },
  { value: "SL", label: COUNTRY_SIERRA_LEONE, phone: "232" },
  { value: "SM", label: COUNTRY_SAN_MARINO, phone: "378" },
  { value: "SN", label: COUNTRY_SENEGAL, phone: "221" },
  { value: "SO", label: COUNTRY_SOMALIA, phone: "252" },
  { value: "SR", label: COUNTRY_SURINAME, phone: "597" },
  { value: "SS", label: COUNTRY_SOUTH_SUDAN, phone: "211" },
  { value: "ST", label: COUNTRY_SAO_TOME_AND_PRINCIPE, phone: "239" },
  { value: "SV", label: COUNTRY_EL_SALVADOR, phone: "503" },
  { value: "SX", label: COUNTRY_SINT_MAARTEN_DUTCH_PART, phone: "1-721" },
  { value: "SY", label: COUNTRY_SYRIAN_ARAB_REPUBLIC, phone: "963" },
  { value: "SZ", label: COUNTRY_SWAZILAND, phone: "268" },
  { value: "TC", label: COUNTRY_TURKS_AND_CAICOS_ISLANDS, phone: "1-649" },
  { value: "TD", label: COUNTRY_CHAD, phone: "235" },
  { value: "TF", label: COUNTRY_FRENCH_SOUTHERN_TERRITORIES, phone: "262" },
  { value: "TG", label: COUNTRY_TOGO, phone: "228" },
  { value: "TH", label: COUNTRY_THAILAND, phone: "66" },
  { value: "TJ", label: COUNTRY_TAJIKISTAN, phone: "992" },
  { value: "TK", label: COUNTRY_TOKELAU, phone: "690" },
  { value: "TL", label: COUNTRY_TIMOR_LESTE, phone: "670" },
  { value: "TM", label: COUNTRY_TURKMENISTAN, phone: "993" },
  { value: "TN", label: COUNTRY_TUNISIA, phone: "216" },
  { value: "TO", label: COUNTRY_TONGA, phone: "676" },
  { value: "TR", label: COUNTRY_TURKEY, phone: "90" },
  { value: "TT", label: COUNTRY_TRINIDAD_AND_TOBAGO, phone: "1-868" },
  { value: "TV", label: COUNTRY_TUVALU, phone: "688" },
  { value: "TW", label: COUNTRY_TAIWAN, phone: "886" },
  { value: "TZ", label: COUNTRY_UNITED_REPUBLIC_OF_TANZANIA, phone: "255" },
  { value: "UA", label: COUNTRY_UKRAINE, phone: "380" },
  { value: "UG", label: COUNTRY_UGANDA, phone: "256" },
  { value: "US", label: COUNTRY_UNITED_STATES, phone: "1" },
  { value: "UY", label: COUNTRY_URUGUAY, phone: "598" },
  { value: "UZ", label: COUNTRY_UZBEKISTAN, phone: "998" },
  { value: "VA", label: COUNTRY_HOLY_SEE_VATICAN_CITY_STATE, phone: "379" },
  {
    value: "VC",
    label: COUNTRY_SAINT_VINCENT_AND_THE_GRENADINES,
    phone: "1-784",
  },
  { value: "VE", label: COUNTRY_VENEZUELA, phone: "58" },
  { value: "VG", label: COUNTRY_BRITISH_VIRGIN_ISLANDS, phone: "1-284" },
  { value: "VI", label: COUNTRY_US_VIRGIN_ISLANDS, phone: "1-340" },
  { value: "VN", label: COUNTRY_VIETNAM, phone: "84" },
  { value: "VU", label: COUNTRY_VANUATU, phone: "678" },
  { value: "WF", label: COUNTRY_WALLIS_AND_FUTUNA, phone: "681" },
  { value: "WS", label: COUNTRY_SAMOA, phone: "685" },
  { value: "XK", label: COUNTRY_KOSOVO, phone: "383" },
  { value: "YE", label: COUNTRY_YEMEN, phone: "967" },
  { value: "YT", label: COUNTRY_MAYOTTE, phone: "262" },
  { value: "ZA", label: COUNTRY_SOUTH_AFRICA, phone: "27" },
  { value: "ZM", label: COUNTRY_ZAMBIA, phone: "260" },
  { value: "ZW", label: COUNTRY_ZIMBABWE, phone: "263" },
];

// CUSTOMER ACQUISITION CONFIGURATION
export const CUSTOMER_ACQUISITION_TYPE_TARGET_ALL_EQUALLY =
  "TARGET_ALL_EQUALLY";
export const CUSTOMER_ACQUISITION_TYPE_BID_HIGHER_FOR_NEW_CUSTOMER =
  "BID_HIGHER_FOR_NEW_CUSTOMER";
export const CUSTOMER_ACQUISITION_LEVEL_ACCOUNT = "ACCOUNT";
export const CUSTOMER_ACQUISITION_LEVEL_CAMPAIGN = "CAMPAIGN";

export const REPORT_GENERATED_BY_BUZZLY_AI_LINK = "https://www.adle.ai/";

// ALERTS ASYNC
export const ALERTS_ASYNC_STATUS = {
  SUCCESS: "success",
  ERROR: "error",
  LOADING: "loading",
  GENERATING: "generating",
};

export const QUESTIONS_CHAT_BOT = [
  CHAT_QUESTION_1,
  CHAT_QUESTION_2,
  CHAT_QUESTION_3,
  CHAT_QUESTION_4,
  CHAT_QUESTION_5,
  CHAT_QUESTION_6,
  CHAT_QUESTION_7,
  CHAT_QUESTION_8,
  CHAT_QUESTION_9,
];

export const AUTH_ROUTES = [
  "/login",
  "/get-started",
  "/onboarding",
  "/verify-auth",
  "/reset-password",
];

export const ROUTE_CAMPAIGNS = "/campaigns";
export const ROUTE_AUTOMATIONS = "/automations";
export const ROUTE_TEMPLATES = "/templates";
export const ROUTE_TEMPLATE = "/template";
export const ROUTE_PRODUCE = "/produce";
export const ROUTE_GALLERY = "/gallery";
export const ROUTE_INSIGHTS = "/insights";
export const ROUTE_GUIDE_TIKTOK_AD_ACCOUNT = "/guides/tiktok-ad-account";
export const ROUTE_NOTIFICATIONS = "/notifications";

export const TEMPLATES_WRITE_ROLES = [
  ADVERTISER_ROLE,
  DESIGNER_ROLE,
  SUPER_ADMIN_ROLE,
  ADMIN_ROLE,
];

export {
  CREATIVE_TEMPLATE_SCHEMA_VERSION,
  CREATIVE_TEMPLATE_MAX_NODES,
  CREATIVE_TEMPLATE_DEFAULT_ARTBOARD_SIZE,
  CREATIVE_TEMPLATE_DEFAULT_ARTBOARD_ID,
  CREATIVE_TEMPLATE_CAROUSEL_CREATE_ENABLED,
  CREATIVE_TEMPLATE_CONTINUOUS_CAROUSEL_ENABLED,
  CREATIVE_TEMPLATE_CONTINUOUS_SLIDE_MIN,
  CREATIVE_TEMPLATE_CONTINUOUS_SLIDE_MAX,
  CREATIVE_TEMPLATE_STRIP_MAX_EDGE,
  CREATIVE_TEMPLATE_STRIP_MAX_PIXELS,
  CREATIVE_TEMPLATE_SLIDE_MIN,
  CREATIVE_TEMPLATE_SLIDE_MAX,
  CREATIVE_TEMPLATE_LAYOUT_KIND,
} from "./creativeTemplateLayout";
export const CREATIVE_TEMPLATE_ARTBOARD_PRESETS = {
  square: { id: "square", label: "1:1", width: 2048, height: 2048 },
  portrait: { id: "portrait", label: "4:5", width: 2048, height: 2560 },
  story: { id: "story", label: "9:16", width: 1152, height: 2048 },
  landscape: { id: "landscape", label: "16:9", width: 2048, height: 1152 },
};
export const CREATIVE_TEMPLATE_STATUS_DRAFT = "draft";
export const CREATIVE_TEMPLATE_STATUS_APPROVED = "approved";
export const CREATIVE_TEMPLATE_STATUS_ARCHIVED = "archived";
export const CREATIVE_TEMPLATE_ANALYSIS_STATUS = {
  PROCESSING: "processing",
  SUCCESS: "success",
  ERROR: "error",
};
export const CREATIVE_TEMPLATE_PRODUCE_STATUS = {
  PROCESSING: "processing",
  SUCCESS: "success",
  PARTIAL: "partial",
  ERROR: "error",
};
export const CREATIVE_TEMPLATE_PRODUCE_INTENT = {
  PREVIEW: "preview",
};
export const CREATIVE_TEMPLATE_SORT_NEWEST_FIRST = "newest_first";
export const CREATIVE_TEMPLATE_SORT_OLDEST_FIRST = "oldest_first";
export const CREATIVE_TEMPLATE_SORT_NAME_ASC = "name_asc";
export const CREATIVE_TEMPLATE_SORT_NAME_DESC = "name_desc";
export const INSIGHTS_CATEGORIES = {
  adTexts: "adTexts",
  assetsGroupsTexts: "assetsGroupsTexts",
  budgets: "budgets",
  keywordsEdit: "keywordsEdit",
  creativeEdit: "creativeEdit",
  customAudiencesEdit: "customAudiencesEdit",
  keywordsNegativeEdit: "keywordsNegativeEdit",
  unknown: "unknown",
};

export const MAP_TRADUCCIONES = {
  status: MAP_TRADUCCIONES_STATUS,
  platform: MAP_TRADUCCIONES_PLATFORM,
  titles: MAP_TRADUCCIONES_TITLES,
  callToAction: MAP_TRADUCCIONES_CTA,
  callToActions: MAP_TRADUCCIONES_CTAS,
  callToActionID: MAP_TRADUCCIONES_CTA_ID,
  mediaUrls: MAP_TRADUCCIONES_MEDIA_URLS,
  mediaData: MAP_TRADUCCIONES_MEDIA_DATA,
  musicUrl: MAP_TRADUCCIONES_MUSIC_URL,
  isCarousel: MAP_TRADUCCIONES_IS_CAROUSEL,
  objective: MAP_TRADUCCIONES_OBJECTIVE,
  integrationID: MAP_TRADUCCIONES_INTEGRATION_ID,
  adAccountID: MAP_TRADUCCIONES_AD_ACCOUNT_ID,
  pageID: MAP_TRADUCCIONES_PAGE_ID,
  instagramID: MAP_TRADUCCIONES_INSTAGRAM_ID,
  useCampaignBudget: MAP_TRADUCCIONES_USE_CAMPAIGN_BUDGET,
  typeBudget: MAP_TRADUCCIONES_TYPE_BUDGET,
  budget: MAP_TRADUCCIONES_BUDGET,
  isCatalogCampaign: MAP_TRADUCCIONES_IS_CATALOG_CAMPAIGN,
  whatsappBusinessNumber: MAP_TRADUCCIONES_WHATSAPP_BUSINESS_NUMBER,
  messageTemplate: MAP_TRADUCCIONES_MESSAGE_TEMPLATE,
  instantForm: MAP_TRADUCCIONES_INSTANT_FORM,
  trackingID: MAP_TRADUCCIONES_TRACKING_ID,
  trackingCustomEventID: MAP_TRADUCCIONES_TRACKING_CUSTOM_EVENT_ID,
  catalogID: MAP_TRADUCCIONES_CATALOG_ID,
  isIOS14Campaign: MAP_TRADUCCIONES_IS_IOS14_CAMPAIGN,
  appID: MAP_TRADUCCIONES_APP_ID,
  buyingType: MAP_TRADUCCIONES_BUYING_TYPE,
  descriptions: MAP_TRADUCCIONES_DESCRIPTIONS,
  ads: MAP_TRADUCCIONES_ADS,
  keywords: MAP_TRADUCCIONES_KEYWORDS,
  keywordsNegative: MAP_TRADUCCIONES_KEYWORDS_NEGATIVE,
  startDate: MAP_TRADUCCIONES_START_DATE,
  endDate: MAP_TRADUCCIONES_END_DATE,
  ageRange: MAP_TRADUCCIONES_AGE_RANGE,
  genders: MAP_TRADUCCIONES_GENDERS,
  locations: MAP_TRADUCCIONES_LOCATIONS,
  interests: MAP_TRADUCCIONES_INTERESTS,
  behaviors: MAP_TRADUCCIONES_BEHAVIORS,
  customAudiences: MAP_TRADUCCIONES_CUSTOM_AUDIENCES,
  excludedCustomAudiences: MAP_TRADUCCIONES_EXCLUDED_CUSTOM_AUDIENCES,
  bidGoal: MAP_TRADUCCIONES_BID_GOAL,
  optimizationGoal: MAP_TRADUCCIONES_OPTIMIZATION_GOAL,
  identityTikTokID: MAP_TRADUCCIONES_IDENTITY_TIKTOK_ID,
  type: MAP_TRADUCCIONES_TYPE,
  id: MAP_TRADUCCIONES_ID,
  destinationUrl: MAP_TRADUCCIONES_DESTINATION_URL,
  businessName: MAP_TRADUCCIONES_BUSINESS_NAME,
  logoUrls: MAP_TRADUCCIONES_LOGO_URLS,
  imageUrls: MAP_TRADUCCIONES_IMAGE_URLS,
  videoUrls: MAP_TRADUCCIONES_VIDEO_URLS,
  longHeadlines: MAP_TRADUCCIONES_LONG_HEADLINES,
  searchThemes: MAP_TRADUCCIONES_SEARCH_THEMES,
};

export const MAP_STATUS = {
  active: MAP_STATUS_ACTIVE,
  deactivated: MAP_STATUS_DEACTIVATED,
};

/**
 * Passive agent panels (run on page load, not typed by the user). The backend
 * only accepts these exact kinds, rebuilds the prompt server-side and does not
 * bill them; any other value is billed as a normal user message.
 * Keep in sync with functions/src/app/ai/automaticAgentRequests.js.
 */
export const AUTOMATIC_AGENT_REQUEST_KINDS = Object.freeze({
  CAMPAIGN_REPORT_SUMMARY: "campaignReportSummary",
  CAMPAIGN_LEARNINGS: "campaignLearnings",
  CAMPAIGN_OPENING_SUMMARY: "campaignOpeningSummary",
  GLOBAL_REPORT_SUMMARY: "globalReportSummary",
  GLOBAL_REPORT_INSIGHTS: "globalReportInsights",
});

export const MAP_CHAT_FROM = {
  report: "report",
  campaign: "campaign",
  globalReport: "globalReport",
};

export const ADS_CAMPAIGN_ACTION_STATUS = {
  creating: "creating",
  updating: "updating",
};

export const IMAGE_TYPE_PORTRAIT = "portrait";
export const IMAGE_TYPE_LANDSCAPE = "landscape";
export const IMAGE_TYPE_SQUARE = "square";

export const imageTypes = [
  { value: IMAGE_TYPE_PORTRAIT, label: IMAGE_TYPE_PORTRAIT_LABEL },
  { value: IMAGE_TYPE_LANDSCAPE, label: IMAGE_TYPE_LANDSCAPE_LABEL },
  { value: IMAGE_TYPE_SQUARE, label: IMAGE_TYPE_SQUARE_LABEL },
];

export const presetDimensions = {
  [IMAGE_TYPE_PORTRAIT]: { width: 1080, height: 1920 },
  [IMAGE_TYPE_LANDSCAPE]: { width: 1200, height: 628 },
  [IMAGE_TYPE_SQUARE]: { width: 1080, height: 1080 },
};

// MODAL CREATE WITH IA
export const MODAL_CREATE_WITH_IA_DIMENSIONS = [
  { value: "1200x1200", label: MODAL_CREATE_WITH_IA_DIMENSION_SQUARE },
  { value: "1920x1080", label: MODAL_CREATE_WITH_IA_DIMENSION_HORIZONTAL },
  { value: "1080x1920", label: MODAL_CREATE_WITH_IA_DIMENSION_VERTICAL },
];

export const MODAL_CREATE_WITH_IA_IMAGE_TYPES = [
  { value: "realistic", label: MODAL_CREATE_WITH_IA_IMAGE_TYPE_REALISTA },
  { value: "product", label: MODAL_CREATE_WITH_IA_IMAGE_TYPE_PRODUCTO },
];

export const MODAL_CREATE_WITH_IA_MEDIA_TYPES = [
  { value: "image", label: MODAL_CREATE_WITH_IA_MEDIA_TYPE_IMAGE },
  {
    value: "video",
    label: MODAL_CREATE_WITH_IA_MEDIA_TYPE_VIDEO,
  },
  {
    value: "carousel",
    label: MODAL_CREATE_WITH_IA_MEDIA_TYPE_CAROUSEL,
  },
];

/** Language codes for text-on-image / carousel (Create with AI). */
export const MODAL_CREATE_WITH_IA_TEXT_LANGUAGE_CODES_IMAGE = [
  "en",
  "es",
  "pt",
  "fr",
  "it",
  "de",
  "nl",
  "da",
  "id",
  "zh-CN",
  "ja",
  "ru",
  "he",
  "hu",
  "cs",
  "pl",
  "tr",
  "el",
];

/** Language codes for on-video text (Create with AI). */
export const MODAL_CREATE_WITH_IA_TEXT_LANGUAGE_CODES_VIDEO = [
  "en",
  "es",
  "pt",
  "fr",
  "de",
  // "da",
  // "id",
  // "zh-CN",
  // "it",
  // "nl",
  // "ru",
  // "cs",
  // "tr",
];

export const OPTIMIZED_FOR_DEFAULT = "default";

export const MODAL_CREATE_WITH_IA_PLATFORMS = [
  {
    value: OPTIMIZED_FOR_DEFAULT,
    label: MODAL_CREATE_WITH_IA_PLATFORM_DEFAULT,
  },
  { value: META, label: META },
  { value: GOOGLE, label: GOOGLE },
  { value: TIKTOK, label: TIKTOK },
  { value: LINKEDIN, label: LINKEDIN },
  { value: ORGANIC, label: ORGANIC },
];

export const MODAL_CREATE_WITH_IA_ASPECT_RATIO_OPTIONS_IMAGE = [
  {
    value: "1:1",
    label: ASPECT_RATIO_1_1,
  },
  {
    value: "4:5",
    label: ASPECT_RATIO_4_5,
  },
  {
    value: "9:16",
    label: ASPECT_RATIO_9_16,
  },
  {
    value: "16:9",
    label: ASPECT_RATIO_16_9,
  },
];

export const MODAL_CREATE_WITH_IA_ASPECT_RATIO_OPTIONS_VIDEO = [
  {
    value: "9:16",
    label: ASPECT_RATIO_9_16,
  },
  {
    value: "16:9",
    label: ASPECT_RATIO_16_9,
  },
];

export const BUSINESS_OFFERING_PHYSICAL_PRODUCT = "physical";
export const BUSINESS_OFFERING_SERVICES = "services";

export const BUSINESS_OFFERING = [
  {
    value: BUSINESS_OFFERING_PHYSICAL_PRODUCT,
    label: BUSINESS_OFFERING_PHYSICAL_PRODUCT_PLACEHOLDER,
  },
  {
    value: BUSINESS_OFFERING_SERVICES,
    label: BUSINESS_OFFERING_SERVICES_PLACEHOLDER,
  },
];

export const SALES_CHANNEL_OPTIONS = [
  { value: "tienda_web", labelKey: PRE_ACTIVATION_SALES_CHANNEL_TIENDA_WEB },
  {
    value: "tienda_fisica",
    labelKey: PRE_ACTIVATION_SALES_CHANNEL_TIENDA_FISICA,
  },
  { value: "whatsapp", labelKey: PRE_ACTIVATION_SALES_CHANNEL_WHATSAPP },
  {
    value: "marketplace",
    labelKey: PRE_ACTIVATION_SALES_CHANNEL_MARKETPLACE,
  },
  { value: "app", labelKey: PRE_ACTIVATION_SALES_CHANNEL_APP },
];

export const HAS_ADS_OPTIONS = [
  { value: "si", labelKey: PRE_ACTIVATION_HAS_ADS_SI },
  { value: "antes", labelKey: PRE_ACTIVATION_HAS_ADS_ANTES },
  { value: "no", labelKey: PRE_ACTIVATION_HAS_ADS_NO },
];

export const ADS_PLATFORM_OPTIONS = [
  { value: "meta", labelKey: PRE_ACTIVATION_ADS_PLATFORM_META },
  { value: "google", labelKey: PRE_ACTIVATION_ADS_PLATFORM_GOOGLE },
  { value: "tiktok", labelKey: PRE_ACTIVATION_ADS_PLATFORM_TIKTOK },
  {
    value: "other",
    labelKey: PRE_ACTIVATION_ADS_PLATFORM_OTHER,
  },
];

export const BUZZLY_FOCUS_OPTIONS = [
  {
    value: "performance",
    labelKey: PRE_ACTIVATION_BUZZLY_FOCUS_PERFORMANCE,
  },
  {
    value: "contenido",
    labelKey: PRE_ACTIVATION_BUZZLY_FOCUS_CONTENIDO,
  },
  {
    value: "ambos",
    labelKey: PRE_ACTIVATION_BUZZLY_FOCUS_AMBOS,
  },
];

export const CREATIVE_MATERIAL_OPTIONS = [
  { value: "si_mucho", labelKey: PRE_ACTIVATION_CREATIVE_MATERIAL_SI_MUCHO },
  { value: "si_poco", labelKey: PRE_ACTIVATION_CREATIVE_MATERIAL_SI_POCO },
  {
    value: "no",
    labelKey: PRE_ACTIVATION_CREATIVE_MATERIAL_NO_IA,
  },
];

export const MEETING_ACCESS_OPTIONS = [
  {
    value: "meta_bm",
    labelKey: PRE_ACTIVATION_MEETING_ACCESS_META_BM,
  },
  { value: "google_ads", labelKey: PRE_ACTIVATION_MEETING_ACCESS_GOOGLE_ADS },
  { value: "tiktok_ads", labelKey: PRE_ACTIVATION_MEETING_ACCESS_TIKTOK_ADS },
  { value: "ga4", labelKey: PRE_ACTIVATION_MEETING_ACCESS_GA4 },
  { value: "pixel", labelKey: PRE_ACTIVATION_MEETING_ACCESS_PIXEL },
  { value: "gtm", labelKey: PRE_ACTIVATION_MEETING_ACCESS_GTM },
];

export const PRE_ACTIVATION_ORGANIZATION_TYPE_OPTIONS = [
  {
    value: "agency",
    labelKey: PRE_ACTIVATION_ORGANIZATION_TYPE_AGENCY_LABEL,
  },
  {
    value: "brand",
    labelKey: PRE_ACTIVATION_ORGANIZATION_TYPE_BRAND_LABEL,
  },
];

export const PRE_ACTIVATION_YES_NO_OPTIONS = [
  { value: "yes", labelKey: PRE_ACTIVATION_OPTION_YES },
  { value: "no", labelKey: PRE_ACTIVATION_OPTION_NO },
];

export const AGENCY_AD_PLATFORM_OPTIONS = [
  { value: "meta", labelKey: PRE_ACTIVATION_ADS_PLATFORM_META },
  { value: "google", labelKey: PRE_ACTIVATION_ADS_PLATFORM_GOOGLE },
  { value: "tiktok", labelKey: PRE_ACTIVATION_ADS_PLATFORM_TIKTOK },
  { value: "linkedin", labelKey: PRE_ACTIVATION_ADS_PLATFORM_LINKEDIN },
];

export const CAL_ONBOARDING_ES =
  "https://cal.com/team/customer-success-adle/onboarding-adle";
export const CAL_ONBOARDING_EN =
  "https://cal.com/team/customer-success-adle/adle-initial-onboarding";

export const PRE_ACTIVATION_BEFORE_START_TIPS = [
  {
    titleKey: PRE_ACTIVATION_BEFORE_START_TIP_1_TITLE,
    descriptionKey: PRE_ACTIVATION_BEFORE_START_TIP_1_DESCRIPTION,
  },
  {
    titleKey: PRE_ACTIVATION_BEFORE_START_TIP_2_TITLE,
    descriptionKey: PRE_ACTIVATION_BEFORE_START_TIP_2_DESCRIPTION,
  },
  {
    titleKey: PRE_ACTIVATION_BEFORE_START_TIP_3_TITLE,
    descriptionKey: PRE_ACTIVATION_BEFORE_START_TIP_3_DESCRIPTION,
  },
  {
    titleKey: PRE_ACTIVATION_BEFORE_START_TIP_4_TITLE,
    descriptionKey: PRE_ACTIVATION_BEFORE_START_TIP_4_DESCRIPTION,
  },
  {
    titleKey: PRE_ACTIVATION_BEFORE_START_TIP_5_TITLE,
    descriptionKey: PRE_ACTIVATION_BEFORE_START_TIP_5_DESCRIPTION,
  },
];

// ENTERPRISE INTAKE options
export const ENTERPRISE_ADLE_MODULE_VALUES = {
  CREATIVE_ASSETS: "creative_assets",
  PAID_MEDIA_LAUNCH: "paid_media_launch",
  PAID_MEDIA_OPTIMIZATION: "paid_media_optimization",
  REPORTS: "reports",
  COMPETITORS: "competitors",
  ORGANIC_SOCIAL: "organic_social",
};

export const ENTERPRISE_ADLE_MODULES_OPTIONS = [
  {
    value: ENTERPRISE_ADLE_MODULE_VALUES.CREATIVE_ASSETS,
    labelKey: ENTERPRISE_INTAKE_MODULE_CREATIVE_ASSETS,
  },
  {
    value: ENTERPRISE_ADLE_MODULE_VALUES.PAID_MEDIA_LAUNCH,
    labelKey: ENTERPRISE_INTAKE_MODULE_PAID_MEDIA_LAUNCH,
  },
  {
    value: ENTERPRISE_ADLE_MODULE_VALUES.PAID_MEDIA_OPTIMIZATION,
    labelKey: ENTERPRISE_INTAKE_MODULE_PAID_MEDIA_IMPORT,
  },
  {
    value: ENTERPRISE_ADLE_MODULE_VALUES.REPORTS,
    labelKey: ENTERPRISE_INTAKE_MODULE_REPORTS,
  },
  {
    value: ENTERPRISE_ADLE_MODULE_VALUES.COMPETITORS,
    labelKey: ENTERPRISE_INTAKE_MODULE_COMPETITORS,
  },
  {
    value: ENTERPRISE_ADLE_MODULE_VALUES.ORGANIC_SOCIAL,
    labelKey: ENTERPRISE_INTAKE_MODULE_ORGANIC_SOCIAL,
  },
];

export const ENTERPRISE_CREATIVES_BUFFER_TYPES_OPTIONS = [
  { value: "statics", labelKey: ENTERPRISE_INTAKE_BUFFER_STATICS },
  { value: "animations", labelKey: ENTERPRISE_INTAKE_BUFFER_ANIMATIONS },
  { value: "videos", labelKey: ENTERPRISE_INTAKE_BUFFER_VIDEOS },
  { value: "none", labelKey: ENTERPRISE_INTAKE_BUFFER_NONE },
];

export const ENTERPRISE_CREATIVES_BUFFER_PERCENT_OPTIONS = [
  { value: "10", labelKey: ENTERPRISE_INTAKE_BUFFER_PERCENT_10 },
  { value: "15", labelKey: ENTERPRISE_INTAKE_BUFFER_PERCENT_15 },
  { value: "20", labelKey: ENTERPRISE_INTAKE_BUFFER_PERCENT_20 },
  { value: "other", labelKey: ENTERPRISE_INTAKE_OTHER_OPTION },
];

export const ENTERPRISE_OPTIMIZATION_FREQUENCY_OPTIONS = [
  {
    value: "low",
    labelKey: ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_LOW,
  },
  {
    value: "medium",
    labelKey: ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_MEDIUM,
  },
  {
    value: "high",
    labelKey: ENTERPRISE_INTAKE_OPTIMIZATION_FREQUENCY_HIGH,
  },
];

export const ENTERPRISE_CONTRACT_TERM_OPTIONS = [
  { value: "6", labelKey: ENTERPRISE_INTAKE_CONTRACT_TERM_6 },
  { value: "12", labelKey: ENTERPRISE_INTAKE_CONTRACT_TERM_12 },
];

export const ENTERPRISE_MEDIA_MANAGEMENT_ADDON_OPTIONS = [
  { value: "yes", labelKey: ENTERPRISE_INTAKE_MEDIA_ADDON_YES },
  { value: "no", labelKey: ENTERPRISE_INTAKE_MEDIA_ADDON_NO },
];

export const ENTERPRISE_WHITE_LABEL_OPTIONS = [
  { value: "yes", labelKey: ENTERPRISE_INTAKE_WHITE_LABEL_YES },
  { value: "no", labelKey: ENTERPRISE_INTAKE_WHITE_LABEL_NO },
];

export const ALERTS_CAMPAIGNS = {
  ALERT_PIXEL_NOT_FIRED: "ALERT_PIXEL_NOT_FIRED",
  ALERT_CAMPAIGN_STARTED: "ALERT_CAMPAIGN_STARTED",
  ALERT_MARKETING_OBJECTIVE_GOOGLE_NOT_SET:
    "ALERT_MARKETING_OBJECTIVE_GOOGLE_NOT_SET",
  ALERT_CAMPAIGN_CPA_HIGH: "ALERT_CAMPAIGN_CPA_HIGH",
  ALERT_AD_ACCOUNT_STATUS: "ALERT_AD_ACCOUNT_STATUS",
  ALERT_DISAPPROVALS_ISSUES: "ALERT_DISAPPROVALS_ISSUES",
  ALERT_AD_ACCOUNT_STATUS_DISABLED: "ALERT_AD_ACCOUNT_STATUS_DISABLED",
  ALERT_AD_ACCOUNT_STATUS_UNSETTLED: "ALERT_AD_ACCOUNT_STATUS_UNSETTLED",
  ALERT_AD_ACCOUNT_STATUS_UNSETTLED_PREPAY:
    "ALERT_AD_ACCOUNT_STATUS_UNSETTLE_PREPAYD",
  ALERT_AD_ACCOUNT_NO_BALANCE: "ALERT_AD_ACCOUNT_NO_BALANCE",
  ALERT_AD_ACCOUNT_STATUS_PENDING_RISK_REVIEW:
    "ALERT_AD_ACCOUNT_STATUS_PENDING_RISK_REVIEW",
  ALERT_AD_ACCOUNT_STATUS_PENDING_SETTLEMENT:
    "ALERT_AD_ACCOUNT_STATUS_PENDING_SETTLEMENT",
  ALERT_AD_ACCOUNT_STATUS_IN_GRACE_PERIOD:
    "ALERT_AD_ACCOUNT_STATUS_IN_GRACE_PERIOD",
  ALERT_AD_ACCOUNT_STATUS_PENDING_CLOSURE:
    "ALERT_AD_ACCOUNT_STATUS_PENDING_CLOSURE",
  ALERT_AD_ACCOUNT_STATUS_CLOSED: "ALERT_AD_ACCOUNT_STATUS_CLOSED",
  ALERT_AD_ACCOUNT_STATUS_ANY_CLOSED: "ALERT_AD_ACCOUNT_STATUS_ANY_CLOSED",
  ALERT_AD_ACCOUNT_STATUS_LIMITED: "ALERT_AD_ACCOUNT_STATUS_LIMITED",
  ALERT_AD_ACCOUNT_STATUS_REVIEW_FAILED:
    "ALERT_AD_ACCOUNT_STATUS_REVIEW_FAILED",
  ALERT_AD_ACCOUNT_STATUS_REVIEW_FAILED_FINAL:
    "ALERT_AD_ACCOUNT_STATUS_REVIEW_FAILED_FINAL",
  ALERT_AD_ACCOUNT_STATUS_MODIFY_REVIEW_FAILED:
    "ALERT_AD_ACCOUNT_STATUS_MODIFY_REVIEW_FAILED",
  ALERT_AD_ACCOUNT_STATUS_PENDING_REVIEW:
    "ALERT_AD_ACCOUNT_STATUS_PENDING_REVIEW",
  ALERT_AD_ACCOUNT_STATUS_PENDING_VERIFICATION:
    "ALERT_AD_ACCOUNT_STATUS_PENDING_VERIFICATION",
  ALERT_AD_ACCOUNT_STATUS_PENDING_MODIFY_REVIEW:
    "ALERT_AD_ACCOUNT_STATUS_PENDING_MODIFY_REVIEW",
  ALERT_AD_ACCOUNT_STATUS_PENDING_CRM_REVIEW:
    "ALERT_AD_ACCOUNT_STATUS_PENDING_CRM_REVIEW",
  ALERT_AD_ACCOUNT_STATUS_PENDING_PUBLIC_AUTH:
    "ALERT_AD_ACCOUNT_STATUS_PENDING_PUBLIC_AUTH",
  ALERT_AD_ACCOUNT_STATUS_PENDING_QUALIFICATION:
    "ALERT_AD_ACCOUNT_STATUS_PENDING_QUALIFICATION",
  ALERT_AD_ACCOUNT_STATUS_CONTRACT_PENDING:
    "ALERT_AD_ACCOUNT_STATUS_CONTRACT_PENDING",
  ALERT_AD_ACCOUNT_STATUS_DRAFT: "ALERT_AD_ACCOUNT_STATUS_DRAFT",
  ALERT_AD_ACCOUNT_STATUS_BILLING_HOLD: "ALERT_AD_ACCOUNT_STATUS_BILLING_HOLD",
  ALERT_AD_ACCOUNT_STATUS_TOTAL_BUDGET_HOLD:
    "ALERT_AD_ACCOUNT_STATUS_TOTAL_BUDGET_HOLD",
  ALERT_AD_ACCOUNT_STATUS_END_DATE_HOLD:
    "ALERT_AD_ACCOUNT_STATUS_END_DATE_HOLD",
  ALERT_AD_ACCOUNT_STATUS_RESTRICTED: "ALERT_AD_ACCOUNT_STATUS_RESTRICTED",
  ALERT_AD_ACCOUNT_STATUS_INTERNAL_HOLD:
    "ALERT_AD_ACCOUNT_STATUS_INTERNAL_HOLD",
  ALERT_AD_ACCOUNT_STATUS_STOPPED: "ALERT_AD_ACCOUNT_STATUS_STOPPED",
  ALERT_AD_ACCOUNT_STATUS_SUSPENDED: "ALERT_AD_ACCOUNT_STATUS_SUSPENDED",
  ALERT_AD_ACCOUNT_STATUS_CANCELED: "ALERT_AD_ACCOUNT_STATUS_CANCELED",
  ALERT_AD_ACCOUNT_STATUS_BILLING_PENDING:
    "ALERT_AD_ACCOUNT_STATUS_BILLING_PENDING",
  ALERT_AD_ACCOUNT_STATUS_BILLING_CANCELLED:
    "ALERT_AD_ACCOUNT_STATUS_BILLING_CANCELLED",
  ALERT_MERCHANT_NO_ELIGIBLE_PRODUCTS: "ALERT_MERCHANT_NO_ELIGIBLE_PRODUCTS",
  ALERT_MERCHANT_PRODUCTS_PARTIAL_ISSUES:
    "ALERT_MERCHANT_PRODUCTS_PARTIAL_ISSUES",
  ALERT_ASSET_GROUP_CPA_LOW: "ALERT_ASSET_GROUP_CPA_LOW",
  ALERT_ASSET_GROUP_CPA_MEDIUM: "ALERT_ASSET_GROUP_CPA_MEDIUM",
  ALERT_ASSET_GROUP_CPA_HIGH: "ALERT_ASSET_GROUP_CPA_HIGH",
  ALERT_AD_GROUP_CPA_LOW: "ALERT_AD_GROUP_CPA_LOW",
  ALERT_AD_GROUP_CPA_MEDIUM: "ALERT_AD_GROUP_CPA_MEDIUM",
  ALERT_AD_GROUP_CPA_HIGH: "ALERT_AD_GROUP_CPA_HIGH",
  ALERT_AD_CPA_LOW: "ALERT_AD_CPA_LOW",
  ALERT_AD_CPA_MEDIUM: "ALERT_AD_CPA_MEDIUM",
  ALERT_AD_CPA_HIGH: "ALERT_AD_CPA_HIGH",
};

export const ALERTS_CAMPAIGNS_TEXT = {
  [ALERTS_CAMPAIGNS.ALERT_MARKETING_OBJECTIVE_GOOGLE_NOT_SET]:
    ALERT_MARKETING_OBJECTIVE_GOOGLE_NOT_SET_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_PIXEL_NOT_FIRED]: ALERT_PIXEL_NOT_FIRED_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_CAMPAIGN_STARTED]: ALERT_CAMPAIGN_STARTED_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_CAMPAIGN_CPA_HIGH]: ALERT_CAMPAIGN_CPA_HIGH_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS]: ALERT_AD_ACCOUNT_STATUS_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_DISABLED]:
    ALERT_AD_ACCOUNT_STATUS_DISABLED_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_UNSETTLED]:
    ALERT_AD_ACCOUNT_STATUS_UNSETTLED_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_UNSETTLED_PREPAY]:
    ALERT_AD_ACCOUNT_STATUS_UNSETTLED_PREPAY_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_PENDING_RISK_REVIEW]:
    ALERT_AD_ACCOUNT_STATUS_PENDING_RISK_REVIEW_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_PENDING_SETTLEMENT]:
    ALERT_AD_ACCOUNT_STATUS_PENDING_SETTLEMENT_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_IN_GRACE_PERIOD]:
    ALERT_AD_ACCOUNT_STATUS_IN_GRACE_PERIOD_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_PENDING_CLOSURE]:
    ALERT_AD_ACCOUNT_STATUS_PENDING_CLOSURE_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_CLOSED]:
    ALERT_AD_ACCOUNT_STATUS_CLOSED_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_ANY_CLOSED]:
    ALERT_AD_ACCOUNT_STATUS_ANY_CLOSED_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_LIMITED]:
    ALERT_AD_ACCOUNT_STATUS_LIMITED_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_REVIEW_FAILED]:
    ALERT_AD_ACCOUNT_STATUS_REVIEW_FAILED_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_REVIEW_FAILED_FINAL]:
    ALERT_AD_ACCOUNT_STATUS_REVIEW_FAILED_FINAL_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_MODIFY_REVIEW_FAILED]:
    ALERT_AD_ACCOUNT_STATUS_MODIFY_REVIEW_FAILED_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_PENDING_REVIEW]:
    ALERT_AD_ACCOUNT_STATUS_PENDING_REVIEW_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_PENDING_VERIFICATION]:
    ALERT_AD_ACCOUNT_STATUS_PENDING_VERIFICATION_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_PENDING_MODIFY_REVIEW]:
    ALERT_AD_ACCOUNT_STATUS_PENDING_MODIFY_REVIEW_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_PENDING_CRM_REVIEW]:
    ALERT_AD_ACCOUNT_STATUS_PENDING_CRM_REVIEW_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_PENDING_PUBLIC_AUTH]:
    ALERT_AD_ACCOUNT_STATUS_PENDING_PUBLIC_AUTH_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_PENDING_QUALIFICATION]:
    ALERT_AD_ACCOUNT_STATUS_PENDING_QUALIFICATION_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_CONTRACT_PENDING]:
    ALERT_AD_ACCOUNT_STATUS_CONTRACT_PENDING_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_DRAFT]:
    ALERT_AD_ACCOUNT_STATUS_DRAFT_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_BILLING_HOLD]:
    ALERT_AD_ACCOUNT_STATUS_BILLING_HOLD_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_TOTAL_BUDGET_HOLD]:
    ALERT_AD_ACCOUNT_STATUS_TOTAL_BUDGET_HOLD_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_END_DATE_HOLD]:
    ALERT_AD_ACCOUNT_STATUS_END_DATE_HOLD_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_RESTRICTED]:
    ALERT_AD_ACCOUNT_STATUS_RESTRICTED_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_INTERNAL_HOLD]:
    ALERT_AD_ACCOUNT_STATUS_INTERNAL_HOLD_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_STOPPED]:
    ALERT_AD_ACCOUNT_STATUS_STOPPED_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_SUSPENDED]:
    ALERT_AD_ACCOUNT_STATUS_SUSPENDED_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_CANCELED]:
    ALERT_AD_ACCOUNT_STATUS_CANCELED_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_BILLING_PENDING]:
    ALERT_AD_ACCOUNT_STATUS_BILLING_PENDING_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_STATUS_BILLING_CANCELLED]:
    ALERT_AD_ACCOUNT_STATUS_BILLING_CANCELLED_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_MERCHANT_NO_ELIGIBLE_PRODUCTS]:
    ALERT_MERCHANT_NO_ELIGIBLE_PRODUCTS_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_MERCHANT_PRODUCTS_PARTIAL_ISSUES]:
    ALERT_MERCHANT_PRODUCTS_PARTIAL_ISSUES_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_ACCOUNT_NO_BALANCE]:
    ALERT_AD_ACCOUNT_NO_BALANCE_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_ASSET_GROUP_CPA_LOW]: ALERT_ASSET_GROUP_CPA_LOW_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_ASSET_GROUP_CPA_MEDIUM]:
    ALERT_ASSET_GROUP_CPA_MEDIUM_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_ASSET_GROUP_CPA_HIGH]:
    ALERT_ASSET_GROUP_CPA_HIGH_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_GROUP_CPA_LOW]: ALERT_AD_GROUP_CPA_LOW_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_GROUP_CPA_MEDIUM]: ALERT_AD_GROUP_CPA_MEDIUM_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_GROUP_CPA_HIGH]: ALERT_AD_GROUP_CPA_HIGH_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_CPA_LOW]: ALERT_AD_CPA_LOW_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_CPA_MEDIUM]: ALERT_AD_CPA_MEDIUM_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_CPA_HIGH]: ALERT_AD_CPA_HIGH_LABEL,
};

export const CREATIVE_FATIGUE_ALERT_TYPE = "creative_fatigue";

export const CREATIVE_FATIGUE_LEVELS = {
  LOW: "LOW",
  MEDIUM: "MEDIUM",
  HIGH: "HIGH",
};

export const ALERTS_CREATIVE_FATIGUE_TEXT = {
  [CREATIVE_FATIGUE_LEVELS.MEDIUM]: ALERT_CREATIVE_FATIGUE_MEDIUM_LABEL,
  [CREATIVE_FATIGUE_LEVELS.HIGH]: ALERT_CREATIVE_FATIGUE_HIGH_LABEL,
};

export const ALERTS_CREATIVE_FATIGUE_TEXT_TABLE = {
  [CREATIVE_FATIGUE_LEVELS.MEDIUM]: ALERT_CREATIVE_FATIGUE_MEDIUM_TABLE_LABEL,
  [CREATIVE_FATIGUE_LEVELS.HIGH]: ALERT_CREATIVE_FATIGUE_HIGH_TABLE_LABEL,
};

const ALERTS_CAMPAIGNS_TEXT_TABLE_OVERRIDES = {
  [ALERTS_CAMPAIGNS.ALERT_AD_CPA_LOW]: ALERT_AD_CPA_LOW_TABLE_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_CPA_MEDIUM]: ALERT_AD_CPA_MEDIUM_TABLE_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_CPA_HIGH]: ALERT_AD_CPA_HIGH_TABLE_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_ASSET_GROUP_CPA_LOW]:
    ALERT_ASSET_GROUP_CPA_LOW_TABLE_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_ASSET_GROUP_CPA_MEDIUM]:
    ALERT_ASSET_GROUP_CPA_MEDIUM_TABLE_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_ASSET_GROUP_CPA_HIGH]:
    ALERT_ASSET_GROUP_CPA_HIGH_TABLE_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_GROUP_CPA_LOW]: ALERT_AD_GROUP_CPA_LOW_TABLE_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_GROUP_CPA_MEDIUM]:
    ALERT_AD_GROUP_CPA_MEDIUM_TABLE_LABEL,
  [ALERTS_CAMPAIGNS.ALERT_AD_GROUP_CPA_HIGH]:
    ALERT_AD_GROUP_CPA_HIGH_TABLE_LABEL,
};

export const ALERTS_CAMPAIGNS_TEXT_TABLE = {
  ...ALERTS_CAMPAIGNS_TEXT,
  ...ALERTS_CAMPAIGNS_TEXT_TABLE_OVERRIDES,
};

export const MODAL_CREATE_WITH_IA_MAX_CHARACTERS_DESCRIPTION_PROMPT = 1000;

export const CAMPAIGN_PUBLISH_BUTTON_ID = "publish-campaign-button";
export const CAMPAIGN_SAVE_AND_PUBLISH_BUTTON_ID = "save-and-publish-button";

export const CARDS_CHAT_BOT = [
  {
    icon: BookOpen,
    title: CARD_GET_CAMPAIGN_LEARNINGS,
    description: CARD_GET_CAMPAIGN_LEARNINGS_DESCRIPTION,
    question: CARD_GET_CAMPAIGN_LEARNINGS_QUESTION,
  },
  {
    icon: Lightbulb,
    title: CARD_OPTIMIZE_GENERAL,
    description: CARD_OPTIMIZE_GENERAL_DESCRIPTION,
    question: CARD_OPTIMIZE_GENERAL_QUESTION,
  },
  {
    icon: DollarSign,
    title: CARD_MANAGE_BUDGET,
    description: CARD_MANAGE_BUDGET_DESCRIPTION,
    question: CARD_MANAGE_BUDGET_QUESTION,
  },
  {
    icon: FileText,
    title: CARD_GENERATE_COPY,
    description: CARD_GENERATE_COPY_DESCRIPTION,
    question: CARD_GENERATE_COPY_QUESTION,
  },
];

export const CARDS_CAMPAIGN_AGENT = [
  {
    icon: BookOpen,
    title: CAMPAIGN_AGENT_CARD_LEARNINGS_TITLE,
    description: CAMPAIGN_AGENT_CARD_LEARNINGS_DESCRIPTION,
    question: CAMPAIGN_AGENT_CARD_LEARNINGS_QUESTION,
  },
  {
    icon: Lightbulb,
    title: CAMPAIGN_AGENT_CARD_IMPROVE_TITLE,
    description: CAMPAIGN_AGENT_CARD_IMPROVE_DESCRIPTION,
    question: CAMPAIGN_AGENT_CARD_IMPROVE_QUESTION,
  },
  {
    icon: DollarSign,
    title: CAMPAIGN_AGENT_CARD_BUDGET_TITLE,
    description: CAMPAIGN_AGENT_CARD_BUDGET_DESCRIPTION,
    question: CAMPAIGN_AGENT_CARD_BUDGET_QUESTION,
  },
  {
    icon: FileText,
    title: CAMPAIGN_AGENT_CARD_COPY_TITLE,
    description: CAMPAIGN_AGENT_CARD_COPY_DESCRIPTION,
    question: CAMPAIGN_AGENT_CARD_COPY_QUESTION,
  },
];

export const CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLES = [
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_1,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_2,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_3,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_4,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_5,
  CAMPAIGN_AGENT_INPUT_PLACEHOLDER_EXAMPLE_6,
];

export const CAMPAIGN_AGENT_FOLLOW_UP_REPLIES = [
  {
    id: "more",
    icon: "idea",
    title: CAMPAIGN_AGENT_FOLLOW_UP_MORE_TITLE,
    message: CAMPAIGN_AGENT_FOLLOW_UP_MORE_MESSAGE,
  },
  {
    id: "budget",
    icon: "budget",
    title: CAMPAIGN_AGENT_FOLLOW_UP_BUDGET_TITLE,
    message: CAMPAIGN_AGENT_CARD_BUDGET_QUESTION,
  },
  {
    id: "copy",
    icon: "copy",
    title: CAMPAIGN_AGENT_FOLLOW_UP_COPY_TITLE,
    message: CAMPAIGN_AGENT_CARD_COPY_QUESTION,
  },
];

export const QUICK_REPLIES_BOT = [
  {
    icon: BookOpen,
    title: CARD_GET_CAMPAIGN_LEARNINGS,
    question: CARD_GET_CAMPAIGN_LEARNINGS_QUESTION,
  },
  {
    icon: Lightbulb,
    title: CARD_OPTIMIZE_GENERAL,
    question: CARD_OPTIMIZE_GENERAL_QUESTION,
  },
  {
    icon: DollarSign,
    title: CARD_MANAGE_BUDGET,
    question: CARD_MANAGE_BUDGET_QUESTION,
  },
  {
    icon: FileText,
    title: CARD_GENERATE_COPY,
    question: CARD_GENERATE_COPY_QUESTION,
  },
];

export const getHasSomeAdsPlatformBeyondDraft = ({ campaign } = {}) => {
  const states = campaign?.states || {};
  return Object.keys(states).some(
    (key) => states[key] !== ADS_CAMPAIGN_STATUS_DRAFT
  );
};

/** Welcome cards and quick replies: owner → none; all draft → skip learnings; else → skip generate copy. */
export const getFilteredCardsChatBot = ({
  campaign,
  agentContext,
  cards = CARDS_CHAT_BOT,
} = {}) => {
  const isOwnerDashboard = agentContext === OWNER_ROLE;
  if (isOwnerDashboard) return [];
  const hasSomePlatformCreated = getHasSomeAdsPlatformBeyondDraft({ campaign });
  return hasSomePlatformCreated ? cards.slice(0, -1) : cards.slice(1);
};

export const getFilteredQuickRepliesBot = ({ campaign, agentContext } = {}) => {
  return getFilteredCardsChatBot({ campaign, agentContext }).map(
    ({ icon, title, question }) => ({ icon, title, question })
  );
};

export const NPS_RATING_ACTION_CREATE = "create";
export const NPS_RATING_ACTION_PUBLISH = "publish";
export const NPS_RATING_ACTION_ACTIVE_7_DAYS = "active_7_days";
export const NPS_RATING_ACTION_ACTIVE_30_DAYS = "active_30_days";
export const NPS_RATING_ACTION_GENERATE_9_CONTENTS = "generate_9_contents";
export const NPS_COOL_DOWN_DAYS = 7;
export const CHECKLIST_CREATE_CAMPAIGN = "create_first_campaign";
export const CHECKLIST_PUBLISH_CONTENT = "publish_first_content";
export const CHECKLIST_CREATE_CONTENT = "create_first_ia_content";
export const CHECKLIST_BRAND_SETUP = "brand_setup";

// INSTAGRAM CONTENT TYPES
export const INSTAGRAM_CONTENT_TYPE_IMAGE = "IMAGE";
export const INSTAGRAM_CONTENT_TYPE_STORIES = "STORIES";
export const INSTAGRAM_CONTENT_TYPE_REELS = "REELS";
export const INSTAGRAM_CONTENT_TYPE_CAROUSEL = "CAROUSEL";

// INSTAGRAM CONTENT TYPE OPTIONS
export const INSTAGRAM_IMAGE_CONTENT_TYPE_OPTIONS = [
  {
    labelKey: MODAL_UPLOAD_INSTAGRAM_TYPE_POST_LABEL,
    value: INSTAGRAM_CONTENT_TYPE_IMAGE,
  },
  {
    labelKey: MODAL_UPLOAD_INSTAGRAM_TYPE_STORY_LABEL,
    value: INSTAGRAM_CONTENT_TYPE_STORIES,
  },
  {
    labelKey: CONTENT_TYPE_CAROUSEL,
    value: INSTAGRAM_CONTENT_TYPE_CAROUSEL,
  },
];

export const INSTAGRAM_VIDEO_CONTENT_TYPE_OPTIONS = [
  {
    labelKey: MODAL_UPLOAD_INSTAGRAM_TYPE_REEL_LABEL,
    value: INSTAGRAM_CONTENT_TYPE_REELS,
  },
  {
    labelKey: MODAL_UPLOAD_INSTAGRAM_TYPE_STORY_LABEL,
    value: INSTAGRAM_CONTENT_TYPE_STORIES,
  },
];

// FACEBOOK CONTENT TYPES
export const FACEBOOK_CONTENT_TYPE_POST = "POST";
export const FACEBOOK_CONTENT_TYPE_STORIES = "STORIES";
export const FACEBOOK_CONTENT_TYPE_REELS = "REELS";
export const FACEBOOK_CONTENT_TYPE_CAROUSEL = "CAROUSEL";

// FACEBOOK CONTENT TYPE OPTIONS
export const FACEBOOK_IMAGE_CONTENT_TYPE_OPTIONS = [
  {
    labelKey: MODAL_UPLOAD_FACEBOOK_TYPE_POST_LABEL,
    value: FACEBOOK_CONTENT_TYPE_POST,
  },
  {
    labelKey: MODAL_UPLOAD_FACEBOOK_TYPE_STORY_LABEL,
    value: FACEBOOK_CONTENT_TYPE_STORIES,
  },
  {
    labelKey: CONTENT_TYPE_CAROUSEL,
    value: FACEBOOK_CONTENT_TYPE_CAROUSEL,
  },
];

export const FACEBOOK_VIDEO_CONTENT_TYPE_OPTIONS = [
  {
    labelKey: MODAL_UPLOAD_FACEBOOK_TYPE_POST_LABEL,
    value: FACEBOOK_CONTENT_TYPE_POST,
  },
  {
    labelKey: MODAL_UPLOAD_FACEBOOK_TYPE_REEL_LABEL,
    value: FACEBOOK_CONTENT_TYPE_REELS,
  },
  {
    labelKey: MODAL_UPLOAD_FACEBOOK_TYPE_STORY_LABEL,
    value: FACEBOOK_CONTENT_TYPE_STORIES,
  },
];

// TIKTOK CONTENT TYPES
export const TIKTOK_CONTENT_TYPE_IMAGE = "IMAGE";
export const TIKTOK_CONTENT_TYPE_CAROUSEL = "CAROUSEL";
export const TIKTOK_CONTENT_TYPE_VIDEO = "VIDEO";

// TIKTOK CONTENT TYPE OPTIONS
export const TIKTOK_IMAGE_CONTENT_TYPE_OPTIONS = [
  {
    label: MODAL_UPLOAD_TIKTOK_TYPE_POST_LABEL,
    value: TIKTOK_CONTENT_TYPE_IMAGE,
  },
  {
    label: CONTENT_TYPE_CAROUSEL,
    value: TIKTOK_CONTENT_TYPE_CAROUSEL,
  },
];

export const TIKTOK_VIDEO_CONTENT_TYPE_OPTIONS = [
  {
    label: MODAL_UPLOAD_TIKTOK_TYPE_POST_LABEL,
    value: TIKTOK_CONTENT_TYPE_VIDEO,
  },
];

// ADMIN DASHBOARD FILTER STATUS OPTIONS
export const OWNER_DASHBOARD_FILTER_STATUS_OPTIONS = [
  { value: "", label: ALL },
  { value: "active", label: ACTIVE },
  { value: "inactive", label: INACTIVE },
];

export const YOUTUBE_PRIVACY_STATUS = {
  public: "public",
  unlisted: "unlisted",
  private: "private",
};

export const youtubePrivacyStatusOptions = [
  { value: YOUTUBE_PRIVACY_STATUS.public, label: YOUTUBE_PRIVACY_LEVEL_PUBLIC },
  {
    value: YOUTUBE_PRIVACY_STATUS.unlisted,
    label: YOUTUBE_PRIVACY_LEVEL_UNLISTED,
  },
  {
    value: YOUTUBE_PRIVACY_STATUS.private,
    label: YOUTUBE_PRIVACY_LEVEL_PRIVATE,
  },
];

export const BENEFIT_KEYS = {
  CAMPAIGNS: "CAMPAIGNS",
  CREATIVES: "CREATIVES",
  VIDEOS: "VIDEOS",
  ADVERTISERS: "ADVERTISERS",
  STORAGE: "STORAGE",
  MULTI_PLATFORM: "MULTI_PLATFORM",
  AI_AUDIENCE: "AI_AUDIENCE",
  AI_LOCATIONS: "AI_LOCATIONS",
  AI_TEXTS: "AI_TEXTS",
  AI_INSIGHTS: "AI_INSIGHTS",
  SUPPORT: "SUPPORT",
  CREDITS: "CREDITS",
  USERS: "USERS",
  UNLIMITED_SOCIAL_POSTS: "UNLIMITED_SOCIAL_POSTS",
  WHITE_LABEL: "WHITE_LABEL",
};

export const YELLOW_ALERT_TYPES = [
  "ALERT_ASSET_GROUP_CPA_LOW",
  "ALERT_ASSET_GROUP_CPA_MEDIUM",
  "ALERT_ASSET_GROUP_CPA_HIGH",
  "ALERT_AD_GROUP_CPA_LOW",
  "ALERT_AD_GROUP_CPA_MEDIUM",
  "ALERT_AD_GROUP_CPA_HIGH",
  "ALERT_AD_CPA_LOW",
  "ALERT_AD_CPA_MEDIUM",
  "ALERT_AD_CPA_HIGH",
  "ALERT_MERCHANT_NO_ELIGIBLE_PRODUCTS",
  "ALERT_MERCHANT_PRODUCTS_PARTIAL_ISSUES",
  ALERTS_CAMPAIGNS.ALERT_CAMPAIGN_CPA_HIGH,
  CREATIVE_FATIGUE_ALERT_TYPE,
];
export const ALERT_COLORS = {
  error: { background: "#d32f2f", color: "#ffffff", border: "#b71c1c" },
  yellow: { background: "#FACC15", color: "#000000", border: "#dcb103" },
};

export const BRAND_FONTS = [
  "Inter",
  "Helvetica",
  "Helvetica Neue",
  "Arial",
  "Roboto",
  "Open Sans",
  "Poppins",
  "Montserrat",
  "Lato",
  "Source Sans Pro",
  "Source Serif Pro",
  "IBM Plex Sans",
  "IBM Plex Serif",
  "IBM Plex Mono",
  "SF Pro Display",
  "SF Pro Text",
  "Segoe UI",
  "Calibri",
  "Verdana",
  "Tahoma",
  "Noto Sans",
  "Noto Serif",
  "Futura",
  "Avenir",
  "Avenir Next",
  "Gotham",
  "Proxima Nova",
  "Circular",
  "Circular Std",
  "TT Norms",
  "DM Sans",
  "Work Sans",
  "Manrope",
  "Nunito",
  "Mukta",
  "Heebo",
  "Karla",
  "Rubik",
  "Mulish",
  "Ubuntu",
  "PT Sans",
  "PT Serif",
  "Merriweather",
  "Playfair Display",
  "Libre Franklin",
  "Libre Baskerville",
  "Georgia",
  "Times New Roman",
  "Baskerville",
  "Didot",
  "Bodoni",
  "Optima",
  "Franklin Gothic",
  "Neue Haas Grotesk",
  "Akzidenz-Grotesk",
  "Univers",
  "DIN",
  "DIN Next",
  "Trade Gothic",
  "Myriad Pro",
  "Myriad",
  "Overpass",
  "Cabin",
  "Asap",
  "Assistant",
  "Arimo",
  "Red Hat Display",
  "Red Hat Text",
  "Atkinson Hyperlegible",
  "Public Sans",
  "Exo",
  "Exo 2",
  "Sora",
  "Space Grotesk",
  "Lexend",
  "Archivo",
  "Archivo Narrow",
  "Chivo",
  "Figtree",
  "Urbanist",
  "Barlow",
  "Barlow Condensed",
  "Barlow Semi Condensed",
];

export const FEEDBACK_ACTION_LIKE = "like";
export const FEEDBACK_ACTION_DISLIKE = "dislike";

export const LARGE_LOCATION_TYPES = [
  "locality",
  "administrative_area_level_1",
  "administrative_area_level_2",
  "administrative_area_level_3",
  "country",
  "continent",
];

// MAPS RADIUS
export const MAPS_RADIUS = {
  MIN_KM: 2,
  MAX_KM: 80,
  MIN_M: 2000,
  MAX_M: 80000,
};

// MODAL CANVA IMAGE CONFIG
export const MODAL_CANVA_IMAGE_CONFIG_MODE_CREATE = "create";
export const MODAL_CANVA_IMAGE_CONFIG_MODE_EDIT = "edit";
export const MODAL_CANVA_IMAGE_CONFIG_MODE_DISCONNECT = "disconnect";

export const MODAL_CANVA_IMAGE_CONFIG_MODES = {
  CREATE: MODAL_CANVA_IMAGE_CONFIG_MODE_CREATE,
  EDIT: MODAL_CANVA_IMAGE_CONFIG_MODE_EDIT,
  DISCONNECT: MODAL_CANVA_IMAGE_CONFIG_MODE_DISCONNECT,
};

export const MODAL_CANVA_IMAGE_CONFIG_MODE_CONFIG = {
  [MODAL_CANVA_IMAGE_CONFIG_MODE_CREATE]: {
    title: MODAL_CANVA_IMAGE_CONFIG_TITLE,
    description: MODAL_CANVA_IMAGE_CONFIG_DESCRIPTION,
    primaryButtonText: MODAL_CANVA_IMAGE_CONFIG_CREATE_BUTTON,
  },
  [MODAL_CANVA_IMAGE_CONFIG_MODE_EDIT]: {
    title: MODAL_CANVA_IMAGE_CONFIG_EDIT_TITLE,
    description: MODAL_CANVA_IMAGE_CONFIG_EDIT_DESCRIPTION,
    primaryButtonText: MODAL_CANVA_IMAGE_CONFIG_EDIT_BUTTON,
  },
  [MODAL_CANVA_IMAGE_CONFIG_MODE_DISCONNECT]: {
    title: MODAL_CANVA_DISCONNECT_TITLE,
    description: MODAL_CANVA_DISCONNECT_DESCRIPTION,
    primaryButtonText: MODAL_CANVA_DISCONNECT_BUTTON,
  },
};

export const SIGNUP_DISCOVERY_SOURCE_OPTIONS = [
  { value: "email", labelKey: OPTION_EMAIL },
  { value: "meta", labelKey: OPTION_META },
  { value: "google", labelKey: OPTION_GOOGLE },
  { value: "linkedin", labelKey: OPTION_LINKEDIN },
  { value: "llm", labelKey: OPTION_LLM },
  { value: "other", labelKey: OPTION_OTHER },
];

export { APP_SUPPORTED_LANGUAGES } from "./i18nLanguage";

/**
 * Brand fields a learned insight is allowed to land on.
 * Mirrors BRAND_INSIGHT_ALLOWLIST_FIELDS in the functions package.
 */
export const BRAND_INSIGHT_ALLOWLIST_FIELDS = [
  "businessTextStyle",
  "businessLookAndFeel",
];

/** Apply rejected because the brand field already covers the insight. */
export const BRAND_INSIGHT_REASON_ALREADY_IN_CONFIG = "already-in-config";

/** Apply source: raw Global Report card, not a curated playbook insight. */
export const BRAND_INSIGHT_APPLY_SOURCE_GLOBAL_REPORT = "global_report";
